/*!
 * democratic-convention-delegate-count (v1.0.0)
 * Authored by Kenneth Uzquiano for CNN - Tue, 26 Jul 2016 16:38:26 GMT
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "http://i.cdn.turner.com/cnn/interactive/2016/politics/democratic-convention-delegate-count/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _rollCallModResultsTable = __webpack_require__(29);
	
	var _rollCallModResultsCard = __webpack_require__(6);
	
	var _rollCallModPeriodicMap = __webpack_require__(28);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//  Initialization
	//  ---------------
	
	window.CNN = window.CNN || {};
	
	var $ = __webpack_require__(2);
	
	__webpack_require__(70);
	__webpack_require__(69);
	__webpack_require__(30);
	
	//  Import Modules
	//  ---------------
	
	// import * as statesConfig from '../data/states-config.json';
	
	//  Project Variables
	//  ---------------
	
	var interactive = $('#cnn_delegate_roll_call');
	
	//
	
	//  CNN_Delegate_Roll_Call [Class]
	//  @description:   Main class for running the interactive.
	//  ---------------
	
	var CNN_Delegate_Roll_Call = function () {
	    function CNN_Delegate_Roll_Call() {
	        _classCallCheck(this, CNN_Delegate_Roll_Call);
	
	        this.interval = null;
	        this.showFullResults = interactive.hasClass('show-full-results');
	        // this.feed = "http://data.cnn.com/jsonp/interactive/2016/conventions-roll-call/rnc/rnc2016.json";
	        this.feed = "http://data.cnn.com/jsonp/interactive/2016/conventions-roll-call/dnc/dnc2016.json";
	        this.initalized = false;
	        this.data = null;
	
	        this.delegatesRemaining = 0;
	
	        this.resultsCards = [];
	
	        this.init();
	    }
	
	    _createClass(CNN_Delegate_Roll_Call, [{
	        key: 'init',
	        value: function init() {
	            this.loadFeed();
	        }
	
	        // ----------------
	        //  Build
	        // ----------------
	
	    }, {
	        key: 'build',
	        value: function build() {
	            this.createElements();
	            this.buildResultCards();
	            this.buildPeriodicMap();
	            this.buildStateTable();
	
	            this.initalized = true;
	
	            this.startInteractive();
	        }
	    }, {
	        key: 'createElements',
	        value: function createElements() {
	            this.resultsContainer = interactive.find('.cnn-delegate-roll-call--results-container');
	            this.periodicMapElement = interactive.find('.cnn-delegate-roll-call--periodic-map');
	            this.resultsTableElement = interactive.find('.cnn-delegate-roll-call--results-table');
	
	            this.delegatesTotalCounter = interactive.find('.cnn-delegate-roll-call--delegate-count__total');
	            this.delegatesRemainingCounter = interactive.find('.cnn-delegate-roll-call--delegate-count__remaining');
	
	            this.toggleFullResultsBtn = interactive.find('.cnn-delegate-roll-call__toggle-btn');
	            this.toggleFullResultsBtn.on('click', $.proxy(this.toggleClass, this));
	
	            this.overlay = $('.cnn-delegate-roll-call--overlay');
	        }
	    }, {
	        key: 'buildResultCards',
	        value: function buildResultCards() {
	            if (this.resultsContainer && this.resultsContainer.length > 0) {
	                $.each(this.data['candidates'], $.proxy(function (id, val) {
	                    if (parseInt(val['id']) !== 99999) {
	                        var newResultsCard = $("<div id='resultCard" + id + "' class='cnn-delegate-roll-call--results-card" + (id > 1 ? " full-results" : "") + (id > 2 ? " snapshot col-xs-third col-sm-third col-md-third col-lg-third col-xl-third" : " col-xs-4 col-sm-8 col-md-10 col-lg-12 col-xl-12") + "'>");
	                        this.resultsCards.push(new _rollCallModResultsCard.ResultsCard(newResultsCard, { td: this.data['td_k'], nom: this.data['d_nom'] }));
	                        this.resultsContainer.append(newResultsCard);
	                    }
	                }, this));
	            }
	        }
	    }, {
	        key: 'buildPeriodicMap',
	        value: function buildPeriodicMap() {
	            if (this.periodicMapElement && this.periodicMapElement.length > 0) {
	                this.periodicMap = new _rollCallModPeriodicMap.PeriodicMap(this.periodicMapElement);
	            }
	        }
	    }, {
	        key: 'buildStateTable',
	        value: function buildStateTable() {
	            if (this.resultsTableElement && this.resultsTableElement.length > 0) {
	                this.resultsTable = new _rollCallModResultsTable.StateResultsTable(this.resultsTableElement);
	            }
	        }
	    }, {
	        key: 'startInteractive',
	        value: function startInteractive() {
	            $('[data-cnn-sharebar]').children().on('click', onShareButtonClick);
	
	            this.update();
	
	            if (!this.isComplete()) {
	                this.interval = setInterval($.proxy(function () {
	                    if (!this.isComplete()) {
	                        this.loadFeed();
	                    } else {
	                        clearInterval(this.interval);
	                    }
	                }, this), 60000);
	            }
	        }
	
	        // ----------------
	        //  Data
	        // ----------------
	
	    }, {
	        key: 'processData',
	        value: function processData(p_data) {
	            //  Order candidates by top delegate count
	
	            p_data['nationraces'] = p_data['nationraces'].sort(this.sortCandidatesByDelegates);
	
	            //  If no delegates have yet been awarded, then 
	            //  sort Trump and Cruz to the top of the nationraces array.
	
	            // if(parseInt(p_data['nationraces'][0]['rd']) === 0)
	            // {
	            //     var trumpId = $.grep(p_data['candidates'], function(e){ return e['lname'].toLowerCase() === "trump"; })[0]['id'];
	            //     var trumpLocation = p_data['nationraces'].indexOf( $.grep(p_data['nationraces'], function(e){ return parseInt(e['id']) === trumpId; })[0] );
	            //         p_data['nationraces'].unshift( p_data['nationraces'].splice(trumpLocation, 1)[0] );
	            // }
	
	            // if(parseInt(p_data['nationraces'][1]['rd']) === 0)
	            // {
	            //     var cruzId = $.grep(p_data['candidates'], function(e){ return e['lname'].toLowerCase() === "cruz"; })[0]['id'];
	            //     var cruzLocation = p_data['nationraces'].indexOf( $.grep(p_data['nationraces'], function(e){ return parseInt(e['id']) === cruzId; })[0] );
	            //         p_data['nationraces'].splice( 1, 0 , p_data['nationraces'].splice(cruzLocation, 1)[0] );
	            // }
	
	            //  Create object for "Other" to tally results for all other 
	            //  candidates other than the leader.
	
	            var otherResultObject = this.generateOtherCandidateDataObject();
	
	            //  Reset the delegatesRemaining value to the total number of delegates.
	
	            this.delegatesRemaining = p_data['td_k'];
	
	            //  Run through all candidates to calculate the remaining number of delegates, as
	            //  well as tally results for the "Other" object.
	
	            $.each(p_data['nationraces'], $.proxy(function (id, val) {
	                this.delegatesRemaining -= parseInt(val['td']);
	                if (id !== 0) otherResultObject['rd'] += parseInt(val['td']);
	            }, this));
	
	            //  Push in the "Other" object
	            p_data['candidates'].push(this.generateOtherCandidate());
	            p_data['nationraces'].push(otherResultObject);
	
	            return p_data;
	        }
	    }, {
	        key: 'getCandidateById',
	        value: function getCandidateById(p_id, p_src) {
	            var p_id = parseInt(p_id),
	                p_src = p_src || this.data,
	                r_candidate = null;
	
	            if (!isNaN(p_id)) {
	                $.each(p_src['candidates'], function (id, val) {
	                    if (parseInt(val['id']) === p_id) r_candidate = val;
	                });
	            }
	
	            return r_candidate;
	        }
	    }, {
	        key: 'sortCandidatesByName',
	        value: function sortCandidatesByName(a, b) {
	            return a['lname'] > b['lname'];
	        }
	    }, {
	        key: 'sortCandidatesByDelegates',
	        value: function sortCandidatesByDelegates(a, b) {
	            return parseInt(a['rd']) < parseInt(b['rd']) ? 1 : parseInt(a['rd']) > parseInt(b['rd']) ? -1 : 0;
	        }
	    }, {
	        key: 'generateOtherCandidateDataObject',
	        value: function generateOtherCandidateDataObject() {
	            return {
	                "id": 99999,
	                "rd": 0
	            };
	        }
	    }, {
	        key: 'generateOtherCandidate',
	        value: function generateOtherCandidate() {
	            return {
	                "id": 99999,
	                "fname": "",
	                "lname": "Other",
	                "nominee": false
	            };
	        }
	    }, {
	        key: 'calculateOtherCandidateResults',
	        value: function calculateOtherCandidateResults(obj, candidateArray, omitId) {
	            omitId = omitId != null ? omitId : -9999;
	
	            $.each(candidateArray, function (i, v) {
	                if (parseInt(v['id']) !== omitId) {
	                    obj['rd'] += parseInt(v['rd']);
	                }
	            });
	
	            return obj;
	        }
	
	        // ----------------
	        //  Update
	        // ----------------
	
	    }, {
	        key: 'update',
	        value: function update() {
	            this.updateDelegates();
	            this.updateResultsCards();
	            this.updateStateData();
	        }
	    }, {
	        key: 'updateDelegates',
	        value: function updateDelegates() {
	            this.delegatesTotalCounter.html(this.data['td_k_s']);
	            this.delegatesRemainingCounter.html(formatNumber(this.delegatesRemaining));
	        }
	    }, {
	        key: 'updateResultsCards',
	        value: function updateResultsCards() {
	            if (this.showFullResults) {
	                $.each(this.resultsCards, $.proxy(function (id, val) {
	                    val.update(this.data['nationraces'][id]);
	                }, this));
	            } else {
	                this.resultsCards[0].update(this.data['nationraces'][0]);
	                this.resultsCards[1].update(this.data['nationraces'][this.data['nationraces'].length - 1]);
	            }
	        }
	    }, {
	        key: 'updateStateData',
	        value: function updateStateData() {
	            //  Update Table with top two candidates, or "Other" if showAllResults is false.
	            //  ------------
	
	            var tableCandidates = [this.data['nationraces'][0], this.showFullResults ? this.data['nationraces'][1] : this.data['nationraces'][this.data['nationraces'].length - 1]];
	
	            if (this.resultsTable) this.resultsTable.data = tableCandidates;
	
	            if (this.periodicMap) {
	                if (this.periodicMap.legend.length === 0) {
	                    this.periodicMap.addCandidateToLegend(this.getCandidateById(this.data['nationraces'][0]['id']));
	                    this.periodicMap.addCandidateToLegend(this.showFullResults ? this.getCandidateById(this.data['nationraces'][1]['id']) : this.generateOtherCandidate());
	                }
	            }
	
	            //  Update both the PeriodicMap and State Table.
	
	            $.each(this.data['states'], $.proxy(function (id, val) {
	                //  Sort state by state candidate data by most delegates awarded.
	
	                val['candidates'] = val['candidates'].sort(this.sortCandidatesByDelegates);
	
	                //  Update Tiles
	                //  ------------
	
	                if (this.periodicMap !== null) {
	                    if (parseInt(val['candidates'][0]['rd']) !== 0) {
	                        var tile = this.periodicMap.getTileById(val['code']);
	                        if (tile) tile.data = val;
	
	                        this.periodicMap.addCandidateToLegend(this.getCandidateById(val['candidates'][0]['id']));
	                    }
	                }
	
	                //  Update Table Items
	                //  ------------------
	
	                if (this.resultsTable !== null) {
	                    var item = this.resultsTable.getItemById(val['code']);
	
	                    if (item) {
	                        var firstCandidate = $.grep(val['candidates'], function (e) {
	                            return parseInt(e['id']) === parseInt(tableCandidates[0]['id']);
	                        })[0];
	                        var secondCandidate = this.showFullResults ? $.grep(val['candidates'], function (e) {
	                            return parseInt(e['id']) === parseInt(tableCandidates[1]['id']);
	                        })[0] : this.calculateOtherCandidateResults(this.generateOtherCandidateDataObject(), val['candidates'], parseInt(tableCandidates[0]['id']));
	
	                        item.data = [firstCandidate, secondCandidate];
	                    }
	                }
	            }, this));
	        }
	
	        // ----------------
	        //  Methods
	        // ----------------
	
	    }, {
	        key: 'showAllResults',
	        value: function showAllResults(p_showResults) {
	            switch (p_showResults) {
	                case undefined:case null:
	                    interactive.toggleClass('show-full-results');
	                    break;
	
	                case true:
	                    if (!interactive.hasClass('show-full-results')) interactive.addClass('show-full-results');
	                    break;
	
	                case false:default:
	                    if (interactive.hasClass('show-full-results')) interactive.removeClass('show-full-results');
	                    break;
	            }
	
	            interactive.removeClass('show-full-results__active');
	
	            this.showFullResults = interactive.hasClass('show-full-results');
	            this.update();
	        }
	    }, {
	        key: 'toggleClass',
	        value: function toggleClass(e) {
	            var target = $(e.currentTarget),
	                toggleClass = target.data('action');
	
	            interactive.toggleClass(toggleClass);
	        }
	    }, {
	        key: 'isModule',
	        value: function isModule() {
	            return interactive.hasClass('hp-module');
	        }
	    }, {
	        key: 'isComplete',
	        value: function isComplete() {
	            return interactive.hasClass('complete');
	        }
	    }, {
	        key: 'loadFeed',
	        value: function loadFeed() {
	            $.ajax(this.feed, {
	                dataType: "jsonp",
	                jsonpCallback: "jsonpCallback"
	            }).done($.proxy(this.onLoadFeedSuccess, this)).error($.proxy(this.onLoadFeedError, this));
	        }
	
	        // ----------------
	        //  Events
	        // ----------------
	
	    }, {
	        key: 'onLoadFeedSuccess',
	        value: function onLoadFeedSuccess(p_data) {
	            // console.log("Data loaded successfully!");
	
	            this.data = this.processData(p_data);
	
	            if (this.initalized === false) {
	                this.build();
	            } else {
	                this.update();
	            }
	        }
	    }, {
	        key: 'onLoadFeedError',
	        value: function onLoadFeedError(err) {
	            console.error("Error loading feed");
	            console.error(err);
	        }
	    }]);
	
	    return CNN_Delegate_Roll_Call;
	}();
	
	function formatNumber(p_num) {
	    return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	
	function shareCustomPost(post, service, popwidth, popheight, popscroll) {
	    post = post || "CNN";
	    service = service || "facebook";
	    popscroll = popscroll = 'no';
	    popheight = popheight = 420;
	    popwidth = popwidth = 550;
	
	    cnnshare.share.popup(post, service, popwidth, popheight, popscroll);
	    cnnshare.share.track({
	        "type": "click",
	        "site": service
	    });
	}
	
	function onShareButtonClick(e) {
	    //  Extract the share data from the parent of the button pressed,
	    //  and set those values to be passed along to the CNNShare module.
	
	    var btn = $(e.currentTarget),
	        shareData = btn.parent().data(),
	        service = btn.data('service'),
	        title = shareData.headline || "default name",
	        facebookDescription = shareData.facebookDescription || "default facebookDescription",
	        twitterDescription = shareData.twitterDescription || "default twitterDescription",
	        img_url = shareData.image || "default image url",
	        bitlyUrl = shareData.bitlyurl || "default url",
	        url = shareData.url || "default url",
	        popscroll = 'no',
	        popheight = 420,
	        popwidth = 550,
	        post = "";
	
	    switch (service) {
	        case 'twitter':
	            post = 'http://twitter.com/intent/tweet?url=' + encodeURIComponent(bitlyUrl);
	            post += '&text=' + encodeURIComponent(twitterDescription);
	            post += '&related=cnnmultimedia&via=cnn';
	            break;
	
	        case 'facebook':
	            post = "http://www.facebook.com/dialog/feed?display=popup&app_id=80401312489";
	            post += "&link=" + encodeURIComponent(url);
	            post += "&name=" + encodeURIComponent(title);
	            post += "&description=" + encodeURIComponent(facebookDescription);
	            post += "&redirect_uri=" + encodeURIComponent("http://www.cnn.com/");
	            post += "&picture=" + encodeURIComponent(img_url);
	            break;
	
	        case 'email':
	        default:
	            post = 'mailto:?to=&subject=On%20CNN:%20' + encodeURIComponent(title) + '&body=' + encodeURIComponent(title) + '%0D%0A%0D%0A' + encodeURIComponent(url);
	            popheight = 150;
	            popwidth = 150;
	            break;
	    }
	
	    shareCustomPost(post, service, popwidth, popheight, popscroll);
	}
	
	CNN.interactive = CNN.interactive || {};
	CNN.interactive.roll_call = CNN.interactive.roll_call || new CNN_Delegate_Roll_Call();

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(39);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "media/assets/winner.png";

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(9),
	    isObject = __webpack_require__(4);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtorWrapper(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtorWrapper;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// var $ = $ || jQuery;
	var $ = __webpack_require__(2);
	
	// ====================================
	//  Results Card
	// ====================================
	
	var ResultsCard = function () {
	    function ResultsCard(p_element, p_config) {
	        _classCallCheck(this, ResultsCard);
	
	        this._element = null;
	
	        this.statusIndicator = null;
	        this.statusBar = null;
	        this.status = null;
	
	        this.winner = null;
	        this.title = null;
	        this.image = null;
	        this.rd = null;
	        this.td = null;
	
	        this.data = null;
	
	        this.totalDelegates = p_config.td || 0;
	        this.neededToWin = p_config.nom || 0;
	
	        if (this.element = p_element || null) this.init();
	    }
	
	    _createClass(ResultsCard, [{
	        key: 'init',
	        value: function init() {}
	    }, {
	        key: 'buildCard',
	        value: function buildCard(p_element) {
	            //  Capture base styles
	            this.baseStyleClass = p_element.attr('class');
	
	            //  Build main display
	            this.image = $("<div class='cnn-delegate-roll-call__image'><img class='cnn-delegate-roll-call__image__src' /></div>").appendTo(p_element);
	            this.rd = $("<p class='cnn-delegate-roll-call--results-card__rd' data-rd=\"0\"></p>").appendTo(p_element);
	
	            //  Build status
	            this.status = $("<div class='cnn-delegate-roll-call--results-card__status'></div>").appendTo(p_element);
	
	            //  Build status bar
	            this.statusBar = $("<div class='cnn-delegate-roll-call--results-card--status-bar'></div>").appendTo(this.status);
	            this.statusIndicator = $("<div class='cnn-delegate-roll-call--results-card--status-bar__indicator'></div>").appendTo(this.statusBar);
	
	            //  Build status labels
	            this.td = $("<p class='cnn-delegate-roll-call--results-card__td' data-td=\"0\">" + formatNumber(this.totalDelegates) + "</p>").appendTo(this.status);
	            this.nom = $("<p class='cnn-delegate-roll-call--results-card__nom' data-nom=\"0\">" + formatNumber(this.neededToWin) + "</p>").appendTo(this.status);
	
	            this.title = $("<h4 class='cnn-delegate-roll-call__title'>Title</h4>").appendTo(p_element);
	            this.winner = $("<span class='cnn-delegate-roll-call__winner'></span>").appendTo(p_element);
	
	            return p_element;
	        }
	    }, {
	        key: 'deconstructCard',
	        value: function deconstructCard() {}
	    }, {
	        key: 'update',
	        value: function update(p_data) {
	            if (this.element) {
	                if (p_data) {
	                    if (p_data !== this.data) {
	                        //  If this is the first time the card is recieving data OR the candidate has been updated.
	
	                        if (this.data === null || p_data['id'] && p_data['id'] !== this.data['id']) {
	                            var candidate = getCandidateById(p_data['id']),
	                                candidateName = candidate['lname'].toLowerCase();
	
	                            this.element.attr({ 'class': this.baseStyleClass + " " + candidateName });
	
	                            if (this.title) this.title.html(candidateName);
	
	                            if (!isModule()) {
	                                if (this.image) this.image.find('img').attr({ 'src': ("http://i.cdn.turner.com/cnn/interactive/2016/politics/democratic-convention-delegate-count/") + 'media/images/' + candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg') });
	                            }
	                        }
	
	                        //  If there are votes to display
	
	                        if (!isNaN(parseInt(p_data['rd'])) && (p_data['rd'] !== undefined || p_data['rd'] !== null)) {
	                            if (this.rd) this.rd.data({ 'rd': parseInt(p_data['rd']) }).html(formatNumber(p_data['rd']));
	                            if (this.statusIndicator) this.statusIndicator.css({ 'width': parseInt(p_data['rd']) / this.totalDelegates * 100 + "%" });
	
	                            if (parseInt(p_data['rd']) >= this.neededToWin) {
	                                this.element.addClass('winner');
	                            } else {
	                                this.element.removeClass('winner');
	                            }
	                        }
	
	                        //  Set data as new data;
	
	                        this.data = p_data;
	                    }
	                    // else
	                    // {
	                    //     console.log("Data hasn't changed.")
	                    // }
	                } else {
	                    console.warn("No data was supplied.");
	                }
	            } else {
	                console.warn("This ResultsCard is not connected to a DOM element. Please assign a DOM element to this card.");
	            }
	        }
	
	        // ----------------------------
	        //  Getters / Setters
	        // ----------------------------
	
	    }, {
	        key: 'element',
	        get: function get() {
	            return this._element;
	        },
	        set: function set(p_element) {
	            if (this._element !== null) {
	                this.deconstructCard();
	            }
	
	            this._element = this.buildCard(p_element);
	        }
	    }]);
	
	    return ResultsCard;
	}();
	
	// ====================================
	//  Helper Functions
	// ====================================
	
	function formatNumber(p_num) {
	    return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	
	function showFullResults() {
	    return CNN.interactive.roll_call.showFullResults;
	}
	
	function isModule() {
	    return CNN.interactive.roll_call.isModule();
	}
	
	function getData() {
	    return CNN.interactive.roll_call.data;
	}
	
	function getOverlay() {
	    return CNN.interactive.roll_call.overlay;
	}
	
	function getCandidateById(p_id) {
	    return CNN.interactive.roll_call.getCandidateById(p_id);
	}
	
	// ====================================
	//  Exports
	// ====================================
	
	exports.ResultsCard = ResultsCard;

/***/ },
/* 7 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(9),
	    baseLodash = __webpack_require__(10);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 11 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = [{
	    "short": "AL",
	    "long": "alabama",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "60"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "50"
	    }]
	}, {
	    "short": "AK",
	    "long": "alaska",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "20"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "28"
	    }]
	}, {
	    "short": "AS",
	    "long": "american samoa",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "11"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "9"
	    }]
	}, {
	    "short": "AZ",
	    "long": "arizona",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "85"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "58"
	    }]
	}, {
	    "short": "AR",
	    "long": "arkansas",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "37"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "40"
	    }]
	}, {
	    "short": "CA",
	    "long": "california",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "551"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "172"
	    }]
	}, {
	    "short": "CO",
	    "long": "colorado",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "78"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "37"
	    }]
	}, {
	    "short": "CT",
	    "long": "connecticut",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "71"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "28"
	    }]
	}, {
	    "short": "DE",
	    "long": "delaware",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "32"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "16"
	    }]
	}, {
	    "short": "DC",
	    "long": "district of columbia",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "44"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "19"
	    }]
	}, {
	    "short": "FL",
	    "long": "florida",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "246"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "99"
	    }]
	}, {
	    "short": "GA",
	    "long": "georgia",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "117"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "76"
	    }]
	}, {
	    "short": "GU",
	    "long": "guam",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "12"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "9"
	    }]
	}, {
	    "short": "HI",
	    "long": "hawaii",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "34"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "19"
	    }]
	}, {
	    "short": "ID",
	    "long": "idaho",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "27"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "32"
	    }]
	}, {
	    "short": "IL",
	    "long": "illinois",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "183"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "69"
	    }]
	}, {
	    "short": "IN",
	    "long": "indiana",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "92"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "57"
	    }]
	}, {
	    "short": "IA",
	    "long": "iowa",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "51"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "30"
	    }]
	}, {
	    "short": "KS",
	    "long": "kansas",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "37"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "40"
	    }]
	}, {
	    "short": "KY",
	    "long": "kentucky",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "60"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "46"
	    }]
	}, {
	    "short": "LA",
	    "long": "louisiana",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "59"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "46"
	    }]
	}, {
	    "short": "ME",
	    "long": "maine",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "30"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "23"
	    }]
	}, {
	    "short": "MD",
	    "long": "maryland",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "120"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "38"
	    }]
	}, {
	    "short": "MA",
	    "long": "massachusetts",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "115"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "42"
	    }]
	}, {
	    "short": "MI",
	    "long": "michigan",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "147"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "59"
	    }]
	}, {
	    "short": "MN",
	    "long": "minnesota",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "93"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "38"
	    }]
	}, {
	    "short": "MS",
	    "long": "mississippi",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "41"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "40"
	    }]
	}, {
	    "short": "MO",
	    "long": "missouri",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "84"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "52"
	    }]
	}, {
	    "short": "MP",
	    "long": "northern mariana islands",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "11"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "9"
	    }]
	}, {
	    "short": "MT",
	    "long": "montana",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "27"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "27"
	    }]
	}, {
	    "short": "NE",
	    "long": "nebraska",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "30"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "36"
	    }]
	}, {
	    "short": "NV",
	    "long": "nevada",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "43"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "30"
	    }]
	}, {
	    "short": "NH",
	    "long": "new hampshire",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "32"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "23"
	    }]
	}, {
	    "short": "NJ",
	    "long": "new jersey",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "142"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "51"
	    }]
	}, {
	    "short": "NM",
	    "long": "new mexico",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "43"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "24"
	    }]
	}, {
	    "short": "NY",
	    "long": "new york",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "291"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "95"
	    }]
	}, {
	    "short": "NC",
	    "long": "north carolina",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "120"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "72"
	    }]
	}, {
	    "short": "ND",
	    "long": "north dakota",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "23"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "28"
	    }]
	}, {
	    "short": "OH",
	    "long": "ohio",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "160"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "66"
	    }]
	}, {
	    "short": "OK",
	    "long": "oklahoma",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "42"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "43"
	    }]
	}, {
	    "short": "OR",
	    "long": "oregon",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "74"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "28"
	    }]
	}, {
	    "short": "PA",
	    "long": "pennsylvania",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "208"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "71"
	    }]
	}, {
	    "short": "PR",
	    "long": "puerto rico",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "67"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "23"
	    }]
	}, {
	    "short": "RI",
	    "long": "rhode island",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "33"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "19"
	    }]
	}, {
	    "short": "SC",
	    "long": "south carolina",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "59"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "50"
	    }]
	}, {
	    "short": "SD",
	    "long": "south dakota",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "25"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "29"
	    }]
	}, {
	    "short": "TN",
	    "long": "tennessee",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "75"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "58"
	    }]
	}, {
	    "short": "TX",
	    "long": "texas",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "251"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "155"
	    }]
	}, {
	    "short": "UT",
	    "long": "utah",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "37"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "40"
	    }]
	}, {
	    "short": "VT",
	    "long": "vermont",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "26"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "16"
	    }]
	}, {
	    "short": "VA",
	    "long": "virginia",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "108"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "49"
	    }]
	}, {
	    "short": "VI",
	    "long": "u.s. virgin islands",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "12"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "9"
	    }]
	}, {
	    "short": "WA",
	    "long": "washington",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "118"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "44"
	    }]
	}, {
	    "short": "WV",
	    "long": "west virginia",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "37"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "34"
	    }]
	}, {
	    "short": "WI",
	    "long": "wisconsin",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "96"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "42"
	    }]
	}, {
	    "short": "WY",
	    "long": "wyoming",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "18"
	    }, {
	        "party": "Rep",
	        "totalDelegates": "29"
	    }]
	}, {
	    "short": "DA",
	    "long": "democrats abroad",
	    "races": [{
	        "party": "Dem",
	        "totalDelegates": "17"
	    }]
	}];

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(9),
	    baseLodash = __webpack_require__(10);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(59),
	    metaMap = __webpack_require__(24);
	
	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 17 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 18 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(17),
	    composeArgsRight = __webpack_require__(18),
	    countHolders = __webpack_require__(41),
	    createCtorWrapper = __webpack_require__(5),
	    createRecurryWrapper = __webpack_require__(21),
	    getHolder = __webpack_require__(23),
	    reorder = __webpack_require__(55),
	    replaceHolders = __webpack_require__(11),
	    root = __webpack_require__(1);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    ARY_FLAG = 128,
	    FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtorWrapper(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybridWrapper;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(51),
	    setData = __webpack_require__(25);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return result;
	}
	
	module.exports = createRecurryWrapper;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(24),
	    noop = __webpack_require__(62);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 23 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(37);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(16),
	    now = __webpack_require__(63);
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 150,
	    HOT_SPAN = 16;
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = (function() {
	  var count = 0,
	      lastCalled = 0;
	
	  return function(key, value) {
	    var stamp = now(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return key;
	      }
	    } else {
	      count = 0;
	    }
	    return baseSetData(key, value);
	  };
	}());
	
	module.exports = setData;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _curry = __webpack_require__(58);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var statesConfig = __webpack_require__(13);
	
	// ====================================
	//  Periodic Map
	// ====================================
	
	var byPartyExceptions = (0, _curry2.default)(function (exceptionList, code) {
	    return exceptionList.indexOf(code) === -1;
	});
	
	function generateGeographicalStateMapping(party) {
	
	    var demsOnly = ['DA', 'UN'];
	    var repsOnly = ['UN'];
	
	    /*
	     * This is mirroring the layout on the page for easy reference when
	     * making a change. If the actual layout of the map needs to be
	     * changed (e.g. moving Alaska from the bottom of the map to the
	     * top) then use the section entitled MAP LAYOUT in the periodic-map
	     * sass file.
	     */
	    // const STATES = "                              ME|
	    //                                            VT|NH|
	    //                 WA|ID|MT|ND|MN|IL|WI|MI|NY|MA|RI|
	    //                 OR|NV|WY|SD|IA|IN|OH|PA|NJ|CT|
	    //                 CA|UT|CO|NE|MO|KY|WV|VA|MD|DE|
	    //                    AZ|NM|KS|AR|TN|NC|SC|DC|
	    //                          OK|LA|MS|AL|GA|
	    //                 HI|AK|   TX|            FL|
	    //                 GU|MP|AS|      DA|UN|      PR|VI";
	
	    var STATES = ["ME", "VT", "NH", "WA", "ID", "MT", "ND", "MN", "IL", "WI", "MI", "NY", "MA", "RI", "OR", "NV", "WY", "SD", "IA", "IN", "OH", "PA", "NJ", "CT", "CA", "UT", "CO", "NE", "MO", "KY", "WV", "VA", "MD", "DE", "AZ", "NM", "KS", "AR", "TN", "NC", "SC", "DC", "OK", "LA", "MS", "AL", "GA", "HI", "AK", "TX", "FL", "GU", "MP", "AS", "DA", "UN", "PR", "VI"];
	
	    return STATES.map(function (code) {
	        return code.trim();
	    }).filter(byPartyExceptions(party === 'Dem' ? repsOnly : demsOnly));
	}
	
	var PeriodicMap = function () {
	    function PeriodicMap(p_element) {
	        _classCallCheck(this, PeriodicMap);
	
	        this.element = null;
	        this.legend = [];
	        this.tiles = [];
	
	        if (p_element) {
	            this.element = p_element;
	            this.init();
	        }
	    }
	
	    _createClass(PeriodicMap, [{
	        key: 'init',
	        value: function init() {
	            this.createElements();
	            this.build();
	        }
	    }, {
	        key: 'createElements',
	        value: function createElements() {
	            this.mapContainer = this.element.find('.periodic-map--squares');
	            this.legendContainer = this.element.find('.periodic-map--legend');
	        }
	    }, {
	        key: 'build',
	        value: function build() {
	            this.buildTiles();
	        }
	    }, {
	        key: 'buildTiles',
	        value: function buildTiles() {
	            // var checkDelegateCount = 0;
	
	            $.each(generateGeographicalStateMapping("Dem"), $.proxy(function (id, val) {
	                var newTile = $("<div class='periodic-map--square'></div>");
	                var tileData = $.grep(statesConfig, function (e) {
	                    return e['short'] == val;
	                })[0];
	
	                var newTileObject = new PeriodicMap__Tile(newTile, tileData);
	
	                // checkDelegateCount += parseInt(tileData['races'][0]['totalDelegates']);
	
	                this.tiles.push(newTileObject);
	                this.mapContainer.append(newTile);
	            }, this));
	
	            // console.log("Total added delegates: " + checkDelegateCount);
	        }
	    }, {
	        key: 'addCandidateToLegend',
	        value: function addCandidateToLegend(p_candidateName) {
	            if (!(typeof p_candidateName === "string") || p_candidateName['lname'] !== undefined) {
	                p_candidateName = p_candidateName['lname'].toLowerCase();
	            }
	
	            if (p_candidateName) {
	                if (this.legendContainer.find('.' + p_candidateName).length === 0) {
	                    var newLegendItem = $("<div class='periodic-map--legend__item " + p_candidateName + "' data-name='" + p_candidateName + "'>" + p_candidateName + "</div>");
	
	                    this.legend.push(newLegendItem);
	                    this.legend.sort(function (a, b) {
	                        return a.data('name') === "other" ? 1 : a.data('name') < b.data('name') ? -1 : a.data('name') > b.data('name') ? 1 : 0;
	                    });
	                    this.legendContainer.html(this.legend);
	                }
	            }
	        }
	    }, {
	        key: 'getTileById',
	        value: function getTileById(p_id) {
	            return $.grep(this.tiles, function (e) {
	                return e['id'] == p_id;
	            })[0];
	        }
	    }]);
	
	    return PeriodicMap;
	}();
	
	// ====================================
	//  Periodic Map -- Tile
	// ====================================
	
	var PeriodicMap__Tile = function () {
	    function PeriodicMap__Tile(p_element, p_config) {
	        _classCallCheck(this, PeriodicMap__Tile);
	
	        this.baseClass = null;
	        this.config = null;
	        this.background = null;
	        this.delegates = null;
	        this._data = null;
	
	        this.init(p_element, p_config);
	    }
	
	    _createClass(PeriodicMap__Tile, [{
	        key: 'init',
	        value: function init(p_element, p_config) {
	            if (p_element && p_config) {
	                this.config = p_config;
	                this.element = p_element;
	
	                this.build();
	            }
	        }
	    }, {
	        key: 'build',
	        value: function build() {
	            this.baseClass = this.element.attr('class');
	            this.background = $("<div class='periodic-map--square__background'></div>");
	            this.delegates = $("<p class='periodic-map--square__delegates'>0</p>"); // + this.config['races'][0]['totalDelegates'] + "</p>");
	
	            var labels = $("<div class='periodic-map--square__labels'></div>");
	            labels.append("<h5 class='periodic-map--square__state-name'>" + this.config['short'] + "</h5>");
	            labels.append(this.delegates);
	
	            this.background.append(labels);
	            this.element.append(this.background);
	
	            this.element.on('mouseover', $.proxy(this.onMouseOver, this));
	            this.element.on('click', $.proxy(this.onTileClick, this));
	        }
	    }, {
	        key: 'buildOverlayContent',
	        value: function buildOverlayContent() {
	            var overlayContent = $("<div class='cnn-delegate-roll-call--overlay-content'></div>");
	            var header = $("<div class='cnn-delegate-roll-call--overlay-content--header'></div>");
	            header.append("<h6 class='cnn-delegate-roll-call--overlay-content--header__title'>" + this.config['long'] + "</h6>");
	            header.append("<p class='cnn-delegate-roll-call--overlay-content--header__delegates'>" + this.config['races'][0]['totalDelegates'] + "</p>");
	
	            overlayContent.append(header);
	
	            var list = $("<ul class='cnn-delegate-roll-call--overlay-content--list'></ul>");
	
	            $.each(this.data['candidates'], function (id, val) {
	                if (parseInt(val['rd']) !== 0) {
	
	                    var candidate = getCandidateById(val['id']),
	                        candidateName = candidate['lname'].toLowerCase(),
	                        item = $("<li class='cnn-delegate-roll-call--overlay-content--list__item " + candidateName + " row'></li>"),
	                        img = "<div class='cnn-delegate-roll-call__image'><img class='cnn-delegate-roll-call__image__src' src='" + ("http://i.cdn.turner.com/cnn/interactive/2016/politics/democratic-convention-delegate-count/") + "media/images/" + (candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg')) + "' /></div>",
	                        title = "<h4 class='cnn-delegate-roll-call__title'>" + candidateName + "</h4>",
	                        delegates = "<p class='cnn-delegate-roll-call--overlay-content--list__item__rd' data-rd='" + parseInt(val['rd']) + "'>" + formatNumber(val['rd']) + "</p>";
	
	                    var profile = $("<div class='col-xl-10 col-lg-10 col-md-8 col-sm-6 col-xs-3'>");
	                    var result = $("<div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'>");
	
	                    profile.append(img);
	                    profile.append(title);
	                    result.append(delegates);
	
	                    item.append(profile).append(result);
	
	                    list.append(item);
	
	                    if (id === 0) {
	                        overlayContent.addClass(candidateName);
	                    }
	                }
	            });
	
	            var closebtn = $('<div class="cnn-delegate-roll-call--overlay__close-btn">close</div>');
	            closebtn.one('click', function (e) {
	                getOverlay().removeClass('show');
	            });
	
	            overlayContent.append(list);
	
	            overlayContent.append(closebtn);
	
	            return overlayContent;
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	            if (this.data) {
	                var topCandidate = getCandidateById(this.data['candidates'][0]['id']),
	                    topCandidateName = topCandidate['lname'].toLowerCase();
	
	                if (parseInt(this.data['candidates'][0]['rd']) !== 0) {
	                    this.element.attr({ "class": this.baseClass + " voted " + topCandidateName });
	                    this.delegates.html(parseInt(this.data['candidates'][0]['rd']));
	                } else {
	                    this.element.attr({ "class": this.baseClass });
	                    this.delegates.empty();
	                }
	            } else {
	                this.element.attr({ "class": this.baseClass });
	                this.delegates.empty();
	            }
	        }
	
	        // --------------------------
	        //  Events
	        // --------------------------
	
	    }, {
	        key: 'onMouseOver',
	        value: function onMouseOver(e) {
	            if (this.data) {
	                var bp = getBreakpoint();
	
	                if (bp !== "xs" && bp !== "sm") {
	                    if (parseInt(this.data['candidates'][0]['rd']) !== 0) {
	                        var overlay = getOverlay(),
	                            overlay_content = this.buildOverlayContent();
	                        overlay.html(overlay_content);
	
	                        $('html').on('mousemove', $.proxy(this.onMouseMove, this));
	                        $(e.currentTarget).one('mouseout', $.proxy(this.onMouseOut, this));
	
	                        overlay.addClass('show');
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'onMouseMove',
	        value: function onMouseMove(e) {
	            var overlay = getOverlay();
	            overlay.css({ 'left': e.pageX + 10, 'top': e.pageY - $('body').scrollTop() + 10 });
	        }
	    }, {
	        key: 'onMouseOut',
	        value: function onMouseOut(e) {
	            var overlay = getOverlay();
	            overlay.removeClass('show');
	
	            $('html').off('mousemove', $.proxy(this.onMouseMove, this));
	        }
	    }, {
	        key: 'onTileClick',
	        value: function onTileClick(e) {
	            if (this.data) {
	                var bp = getBreakpoint();
	
	                if (bp === "xs" || bp === "sm") {
	                    var overlay = getOverlay(),
	                        overlay_content = this.buildOverlayContent();
	
	                    overlay.attr({ "style": "" });
	                    overlay.html(overlay_content);
	                    overlay.addClass('show');
	                }
	            }
	        }
	
	        // --------------------------
	        //  Getters / Setters
	        // --------------------------
	
	    }, {
	        key: 'data',
	        get: function get() {
	            return this._data;
	        },
	        set: function set(p_data) {
	            this._data = p_data;
	            this.update();
	        }
	    }, {
	        key: 'id',
	        get: function get() {
	            return this.config !== null ? this.config["short"] : undefined;
	        }
	    }]);
	
	    return PeriodicMap__Tile;
	}();
	
	// ====================================
	//  Helper Functions
	// ====================================
	
	function formatNumber(p_num) {
	    return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	
	function showFullResults() {
	    return CNN.interactive.roll_call.showFullResults;
	}
	
	function getData() {
	    return CNN.interactive.roll_call.data;
	}
	
	function getOverlay() {
	    return CNN.interactive.roll_call.overlay;
	}
	
	function getCandidateById(p_id) {
	    return CNN.interactive.roll_call.getCandidateById(p_id);
	}
	
	function getBreakpoint() {
	    //  Return the responsive breakpoint.
	    return window.getComputedStyle ? window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').split("\"").join("") : undefined;
	};
	
	// ====================================
	//  Exports
	// ====================================
	
	exports.PeriodicMap = PeriodicMap;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = __webpack_require__(2);
	var statesConfig = statesConfig || __webpack_require__(13);
	
	// ====================================
	//  State Results Table
	// ====================================
	
	var StateResultsTable = function () {
	    function StateResultsTable(p_element) {
	        _classCallCheck(this, StateResultsTable);
	
	        this.element = null;
	
	        this.candidates = [];
	        this.items = [];
	
	        if (p_element) {
	            this.init(p_element);
	        }
	    }
	
	    _createClass(StateResultsTable, [{
	        key: 'init',
	        value: function init(p_element) {
	            if (p_element) {
	                this.element = p_element;
	                this.build();
	            }
	        }
	    }, {
	        key: 'build',
	        value: function build() {
	            this.createElements();
	
	            this.buildHeader();
	            this.buildStateRows();
	        }
	    }, {
	        key: 'createElements',
	        value: function createElements() {
	            this.header = this.element.find('.cnn-delegate-roll-call--results-table--header');
	            this.list = this.element.find('.cnn-delegate-roll-call--results-table--list');
	        }
	    }, {
	        key: 'buildHeader',
	        value: function buildHeader() {
	            var headerRow = $('<div class="row"></div>');
	
	            this.header.append(headerRow);
	
	            headerRow.append("<h5 class='cnn-delegate-roll-call--results-table--header__title col-xl-8 col-lg-8 col-md-6 col-sm-4 col-xs-2'>Total delegates</h5>");
	            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--header__candidate col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));
	            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--header__candidate col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));
	
	            headerRow.append(this.candidates);
	        }
	    }, {
	        key: 'buildStateRows',
	        value: function buildStateRows() {
	            statesConfig = statesConfig.sort(function (a, b) {
	                return a.long > b.long ? 1 : a.long < b.long ? -1 : 0;
	            });
	
	            $.each(statesConfig, $.proxy(function (id, val) {
	                var newRow = $('<li class="cnn-delegate-roll-call--results-table--list__item"></li>');
	                this.items.push(new StateResultsTable__Item(newRow, val));
	                this.list.append(newRow);
	            }, this));
	        }
	    }, {
	        key: 'update',
	        value: function update(p_data) {
	            if (p_data) {
	                $.each(p_data, $.proxy(function (id, val) {
	                    var candidate = getCandidateById(p_data[id]['id']),
	                        candidateName = candidate['lname'].toLowerCase();
	
	                    if (this.data) {
	                        if (parseInt(p_data[id]['id']) !== parseInt(this.data[id]['id'])) {
	                            this.candidates.attr({ "class": "cnn-delegate-roll-call--results-table--header__candidate col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1 " + candidateName });
	
	                            var image = this.candidates[id].find('img'),
	                                title = this.candidates[id].find('h4');
	
	                            title.html(candidateName);
	                            image.attr({ 'src': ("http://i.cdn.turner.com/cnn/interactive/2016/politics/democratic-convention-delegate-count/") + '/media/images/' + candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg') });
	                        }
	
	                        var rd = this.candidates[id].find('[data-rd]');
	                        rd.data({ 'rd': parseInt(val[rd]) }).html(formatNumber(val['rd']));
	                    } else {
	                        this.candidates[id].addClass(candidateName);
	                        this.candidates[id].append("<div class='cnn-delegate-roll-call__image'><img class='cnn-delegate-roll-call__image__src' src='" + ("http://i.cdn.turner.com/cnn/interactive/2016/politics/democratic-convention-delegate-count/") + "/media/images/" + (candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg')) + "' /></div>");
	                        this.candidates[id].append("<h4 class='cnn-delegate-roll-call__title'>" + candidateName + "</h4>");
	                        this.candidates[id].append("<p class='cnn-delegate-roll-call--results-table--header__candidate__rd' data-rd='" + parseInt(val[rd]) + "'>" + formatNumber(val['rd']) + "</h4>");
	                    }
	                }, this));
	            }
	
	            return p_data;
	        }
	    }, {
	        key: 'getItemById',
	        value: function getItemById(p_id) {
	            return $.grep(this.items, function (e) {
	                return e['id'] == p_id;
	            })[0];
	        }
	    }, {
	        key: 'data',
	        get: function get() {
	            return this._data;
	        },
	        set: function set(p_data) {
	            this._data = this.update(p_data);
	        }
	    }]);
	
	    return StateResultsTable;
	}();
	
	// ====================================
	//  State Results Table -- Item
	// ====================================
	
	
	var StateResultsTable__Item = function () {
	    function StateResultsTable__Item(p_element, p_config) {
	        _classCallCheck(this, StateResultsTable__Item);
	
	        this._data = null;
	        this.config = null;
	        this.element = null;
	        this.candidates = [];
	
	        if (p_element && p_config) {
	            this.init(p_element, p_config);
	        }
	    }
	
	    _createClass(StateResultsTable__Item, [{
	        key: 'init',
	        value: function init(p_element, p_config) {
	            if (p_element, p_config) {
	                this.element = p_element;
	                this.config = p_config;
	                this.build();
	            }
	        }
	    }, {
	        key: 'build',
	        value: function build() {
	            var resultsRow = $('<div class="row"></div>');
	
	            this.element.append(resultsRow);
	
	            resultsRow.append("<h5 class='cnn-delegate-roll-call--results-table--list__item__title col-xl-8 col-lg-8 col-md-6 col-sm-4 col-xs-2'>" + this.config['long'] + "</h5>");
	            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--list__item__result col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));
	            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--list__item__result col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));
	
	            resultsRow.append(this.candidates);
	        }
	    }, {
	        key: 'update',
	        value: function update(p_data) {
	            if (p_data) {
	                var totalDelegates = parseInt(this.config['races'][0]['totalDelegates']);
	
	                $.each(p_data, $.proxy(function (id, val) {
	                    var candidate = getCandidateById(val['id']),
	                        candidateName = candidate['lname'].toLowerCase(),
	                        value = $("<p class='cnn-delegate-roll-call--results-table--list__item__result__value " + candidateName + "'>" + val['rd'] + "</p>"),
	                        percent = parseInt(val['rd']) / totalDelegates;
	
	                    this.candidates[id].html(value);
	                }, this));
	            }
	
	            return p_data;
	        }
	    }, {
	        key: 'id',
	        get: function get() {
	            return this.config !== null ? this.config["short"] : undefined;
	        }
	    }, {
	        key: 'data',
	        get: function get() {
	            return _data;
	        },
	        set: function set(p_data) {
	            this._data = this.update(p_data);
	        }
	    }, {
	        key: 'name',
	        get: function get() {
	            return this.config ? this.config['long'] ? this.config['long'] : "undefined" : "undefined";
	        }
	    }]);
	
	    return StateResultsTable__Item;
	}();
	
	// ====================================
	//  Helper Functions
	// ====================================
	
	function formatNumber(p_num) {
	    return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	
	function showFullResults() {
	    return CNN.interactive.roll_call.showFullResults;
	}
	
	function getData() {
	    return CNN.interactive.roll_call.data;
	}
	
	function getOverlay() {
	    return CNN.interactive.roll_call.overlay;
	}
	
	function getCandidateById(p_id) {
	    return CNN.interactive.roll_call.getCandidateById(p_id);
	}
	
	// ====================================
	//  Exports
	// ====================================
	
	exports.StateResultsTable = StateResultsTable;

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	(function ($, ns, win, doc, undefined) {
		/* social media library */
		var cnnshare = {
	
			/* store load configuration for each social site's api */
			'apiconfig': [],
	
			/* set analtyics engine for social tracking */
			'analytics': 'o',
	
			/* set analytics for tracking, o for omniture and b for bango */
			'setanalytics': function setanalytics(a_id) {
	
				cnnshare.analytics = a_id;
			},
	
			/* adds tracking param to manual links */
			'addurlparam': function addurlparam(url, param, value) {
	
				var qstring = /\?.+$/;
				if (qstring.test(url)) {
					return url + '&' + param + '=' + value;
				} else {
					return url + '?' + param + '=' + value;
				}
			},
	
			/* supported social site configurations */
			'sites': {
	
				'email': {
					'buildurl': function buildurl(t_obj) {
						return 'mailto:?to=&subject=On%20CNN:%20' + encodeURIComponent(t_obj.title) + '&body=' + encodeURIComponent(t_obj.title) + '%0D%0A%0D%0A' + encodeURIComponent(cnnshare.addurlparam(t_obj.url, 'sr', 'sharebar_email'));
					},
					'popwidth': 150, 'popheight': 150, 'popscroll': 'no'
	
				},
	
				'facebook': {
					'buildurl': function buildurl(t_obj) {
						return 'http://www.facebook.com/share.php?u=' + encodeURIComponent(cnnshare.addurlparam(t_obj.url, 'sr', 'sharebar_facebook')) + '&title=' + encodeURIComponent(t_obj.title);
					},
					'popwidth': 550, 'popheight': 420, 'popscroll': 'no',
					'loadapi': function loadapi(cb) {
	
						/* call to load api */
						(function (d, debug) {
							var js,
							    id = 'facebook-jssdk',
							    ref = d.getElementsByTagName('script')[0];
							if (d.getElementById(id)) {
								return;
							}
							js = d.createElement('script');js.id = id;js.async = true;
							js.src = "//connect.facebook.net/en_US/all" + (debug ? "/debug" : "") + ".js";
							ref.parentNode.insertBefore(js, ref);
						})(document, /*debug*/false);
	
						window.fbAsyncInit = function () {
	
							FB.init({
								appId: '80401312489', /* App ID */
								status: true, /* check login status */
								cookie: true, /* enable cookies to allow the server to access the session */
								xfbml: true, /* parse XFBML */
								oauth: true
							});
	
							FB.Event.subscribe('edge.create', function (targetUrl) {
								window.cnnshare.share.track({ 'type': 'click', 'site': 'facebook' });
							});
	
							if (typeof cb === 'function') {
								cb.apply();
							}
						};
					}
				},
	
				'twitter': {
					'buildurl': function buildurl(t_obj) {
						return 'http://twitter.com/intent/tweet?url=' + encodeURIComponent(cnnshare.addurlparam(t_obj.url, 'sr', 'sharebar_twitter')) + '&text=' + encodeURIComponent(t_obj.title);
					},
					'popwidth': 550, 'popheight': 460, 'popscroll': 'no',
					'loadapi': function loadapi(cb) {
	
						/* call to load api */
						window.twttr = function (d, s, id) {
	
							var t,
							    js,
							    fjs = d.getElementsByTagName(s)[0];
							if (d.getElementById(id)) return;js = d.createElement(s);js.id = id;
							js.src = "//platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js, fjs);
							return window.twttr || (t = { _e: [], ready: function ready(f) {
									t._e.push(f);
								} });
						}(document, "script", "twitter-wjs");
	
						window.twttr.ready(function (twttr) {
	
							twttr.events.bind('click', function (event) {
								window.cnnshare.share.track({ 'type': 'click', 'site': 'twitter' });
							});
	
							if (typeof cb === 'function') {
								cb.apply();
							}
						});
					}
				}
	
			},
	
			/* share library will be defined below for cleaner code */
			'share': {},
	
			/* specify which apis to load and callbacks to call */
			'setapiconfig': function setapiconfig(api_arr) {
	
				cnnshare.apiconfig = api_arr;
			},
	
			/* initialize cnn social library */
			'init': function init() {
	
				/* load necessary social apis */
				var t_arr = cnnshare.apiconfig;
	
				for (var i = 0; i < t_arr.length; i++) {
	
					var t_api = t_arr[i];
					if (typeof t_api.success === 'function') {
						cnnshare.sites[t_api.site].loadapi(t_api.success);
					} else {
						cnnshare.sites[t_api.site].loadapi();
					}
				}
	
				/* setup share instances */
				if (typeof cnnshare.share.data.bars != 'undefined') {
					cnnshare.share.init();
				}
			}
	
		};
		/* end cnnshare */
	
		/* share library */
		cnnshare.share = {
	
			/* store each instance */
			'data': {
				'bars': {}
			},
	
			/* add a single sharebar instance to data */
			'addconfig': function addconfig(c_obj) {
	
				cnnshare.share.data.bars[c_obj.id] = c_obj;
			},
	
			/* add a multiple config array to data */
			'setconfig': function setconfig(c_arr) {
	
				/* iterate through and add each one */
				for (var i = 0; i < c_arr.length; i++) {
					cnnshare.share.addconfig(c_arr[i]);
				}
			},
	
			/* update the url for all share instances - for dynamic video/ajax-y pages */
			'updateurl': function updateurl(t_url) {
	
				//var t_bar = cnnshare.share.data.bars[t_id]
	
			},
	
			'updatesingleurl': function updatesingleurl(t_id, t_url, t_title) {
	
				var t_bar = cnnshare.share.data.bars[t_id];
				t_bar.url = t_url;
				t_bar.title = t_title;
				cnnshare.share.data.bars[t_id] = t_bar;
			},
	
			/* custom button click function */
			'click': function click(t_id, t_site) {
	
				if (window.console) {
					console.log('clicked ' + t_site + ' in: ' + t_id);
				}
	
				/* trigger share actions */
				var t_bar = cnnshare.share.data.bars[t_id];
				var t_social = cnnshare.sites[t_site];
	
				cnnshare.share.popup(t_social.buildurl(t_bar), t_site, t_social.popwidth, t_social.popheight, t_social.popscroll);
	
				/* track click action */
				cnnshare.share.track({ 'type': 'click', 'site': t_site });
			},
	
			/* launch share url in popup window */
			'popup': function popup(t_url, t_site, t_width, t_height, t_scroll) {
	
				return window.open(t_url, 'cnn_pop_' + t_site, 'width=' + t_width + ',height=' + t_height + ',resizable=yes,scrollbars=' + t_scroll);
			},
	
			/* default tracking callback but we would prefer the setting of a tracking callback in shareconfig */
			'track': function track(t_obj) {
	
				if (window.console) {
					console.log(t_obj);
				}
	
				try {
	
					if (cnnshare.analytics === 'o') {
						if (jsmd) {
							if (t_obj.type === 'click') {
								jsmd.trackMetrics("social-click", { 'clickObj': { 'socialType': t_obj.site + '_click' } });
							} else if (t_obj.type === 'success') {
								jsmd.trackMetrics("social-click", { 'clickObj': { 'socialType': t_obj.site + '_post' } });
							}
						}
					} else if (cnnshare.analytics === 'b') {
						if (typeof bangoSocial === 'function') {
							bangoSocial({ 'socialMedia': t_obj.site });
						}
					}
				} catch (e) {
	
					if (window.console) {
						console.log("error thrown while registering click tracking. Message - " + e.message);
					}
				}
			},
	
			/* start up the sharing */
			'init': function init() {
	
				var t_bars = cnnshare.share.data.bars;
	
				/* interate through each bar instance */
				for (var t_bar in t_bars) {
	
					var t_obj = t_bars[t_bar];
					var t_cntr = '#' + t_obj.id + ' .c_sharebar_cntr';
	
					/* remove loading class for container once DOM is ready */
					jQuery(t_cntr).removeClass('c_sharebar_loading');
				}
			}
	
		};
		/* end cnnshare.share */
	
		win.cnnshare = cnnshare;
	
		/* configure apis to load and specify their callbacks */
		cnnshare.setapiconfig([{
			'site': 'facebook',
			'success': function success() {
				/* trigger connect-cnnsocial.js calls */
				window.cnn_fbAsyncInit();
			}
		}, { 'site': 'twitter' }]);
	
		/* add the multiple config instance for sharebars */
	
		cnnshare.share.setconfig(cnn_shareconfig);
	
		$('.share-button').click(function () {
			cnnshare.share.click('cnn_sharebar1', $j(this).attr('data-service'));
			console.log(jQuery(this).attr('data-service'));
		});
	})(jQuery, CNN, window, document);

/***/ },
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:cnn-icons--legacy;src:url(\"http://i.cdn.turner.com/cnn/.e/fonts/icons/2.0.0/cnn-icons.eot\");src:url(\"http://i.cdn.turner.com/cnn/.e/fonts/icons/2.0.0/cnn-icons.eot?#iefix\") format(\"embedded-opentype\"),url(\"http://i.cdn.turner.com/cnn/.e/fonts/icons/2.0.0/cnn-icons.woff\") format(\"woff\"),url(\"http://i.cdn.turner.com/cnn/.e/fonts/icons/2.0.0/cnn-icons.ttf\") format(\"truetype\"),url(\"http://i.cdn.turner.com/cnn/.e/fonts/icons/2.0.0/cnn-icons.svg?#cnn-icons\") format(\"svg\");font-weight:400;font-style:normal}body{font-size:16px;font-family:CNN,Helvetica Neue,Helvetica,Arial,Utkal,sans-serif;margin:0}body *{box-sizing:border-box}a{text-decoration:none}.full-width{max-width:none;width:100%}.center{margin:0 auto!important}body:before{position:absolute;content:\"xl\";visibility:hidden;text-indent:-99999px;height:0;width:0}.grid-width{max-width:60rem;width:100%}.col.full{width:940px;width:97.91667%;max-width:940px;max-width:58.75rem;margin-right:1.04167%;margin-left:1.04167%}.col-xl-full{width:100%}.col-xl-full.static{width:940px;width:58.75rem}.row .col-xl-full{margin-left:2.08333%;float:left}.row .col-xl-full.static{margin-left:1.25rem}.col-xl-half{width:460px;width:47.91667%;max-width:460px;max-width:28.75rem}.col-xl-half.static{width:460px;width:28.75rem}.row .col-xl-half{margin-left:2.08333%;float:left}.row .col-xl-half.static{margin-left:1.25rem}.col-xl-third{width:300px;width:31.25%;max-width:300px;max-width:18.75rem}.col-xl-third.static{width:300px;width:18.75rem}.row .col-xl-third{margin-left:2.08333%;float:left}.row .col-xl-third.static{margin-left:1.25rem}.col-xl-fourth{width:220px;width:22.91667%;max-width:220px;max-width:13.75rem}.col-xl-fourth.static{width:220px;width:13.75rem}.row .col-xl-fourth{margin-left:2.08333%;float:left}.row .col-xl-fourth.static{margin-left:1.25rem}.col-xl-fifth{width:172px;width:17.91667%;max-width:172px;max-width:10.75rem}.col-xl-fifth.static{width:172px;width:10.75rem}.row .col-xl-fifth{margin-left:2.08333%;float:left}.row .col-xl-fifth.static{margin-left:1.25rem}.col-xl-sixth{width:140px;width:14.58333%;max-width:140px;max-width:8.75rem}.col-xl-sixth.static{width:140px;width:8.75rem}.row .col-xl-sixth{margin-left:2.08333%;float:left}.row .col-xl-sixth.static{margin-left:1.25rem}.col-xl-seventh{width:117.14286px;width:12.20238%;max-width:117.14286px;max-width:7.32143rem}.col-xl-seventh.static{width:117.14286px;width:7.32143rem}.row .col-xl-seventh{margin-left:2.08333%;float:left}.row .col-xl-seventh.static{margin-left:1.25rem}.col-xl-eighth{width:100px;width:10.41667%;max-width:100px;max-width:6.25rem}.col-xl-eighth.static{width:100px;width:6.25rem}.row .col-xl-eighth{margin-left:2.08333%;float:left}.row .col-xl-eighth.static{margin-left:1.25rem}.col-xl-ninth{width:86.66667px;width:9.02778%;max-width:86.66667px;max-width:5.41667rem}.col-xl-ninth.static{width:86.66667px;width:5.41667rem}.row .col-xl-ninth{margin-left:2.08333%;float:left}.row .col-xl-ninth.static{margin-left:1.25rem}.col-xl-tenth{width:76px;width:7.91667%;max-width:76px;max-width:4.75rem}.col-xl-tenth.static{width:76px;width:4.75rem}.row .col-xl-tenth{margin-left:2.08333%;float:left}.row .col-xl-tenth.static{margin-left:1.25rem}.row{margin-left:-2.08333%}.row .col{margin-left:2.08333%;float:left}.ie6 .row,.ie7 .row,.ie8 .row,.row.static{width:auto;margin-left:-1.25rem}.ie6 .row .col,.ie7 .row .col,.ie8 .row .col,.row.static .col{margin-left:1.25rem;float:left}.row:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.col-xl-1{width:60px;width:6.25%;max-width:60px;max-width:3.75rem}.col-xl-1.static,.ie6 .col-xl-1,.ie7 .col-xl-1,.ie8 .col-xl-1{width:60px;width:3.75rem}.row .col-xl-1{margin-left:2.08333%;float:left}.ie6 .row .col-xl-1,.ie7 .row .col-xl-1,.ie8 .row .col-xl-1,.row.static .col-xl-1{margin-left:1.25rem}.col-xl-2{width:140px;width:14.58333%;max-width:140px;max-width:8.75rem}.col-xl-2.static,.ie6 .col-xl-2,.ie7 .col-xl-2,.ie8 .col-xl-2{width:140px;width:8.75rem}.row .col-xl-2{margin-left:2.08333%;float:left}.ie6 .row .col-xl-2,.ie7 .row .col-xl-2,.ie8 .row .col-xl-2,.row.static .col-xl-2{margin-left:1.25rem}.col-xl-3{width:220px;width:22.91667%;max-width:220px;max-width:13.75rem}.col-xl-3.static,.ie6 .col-xl-3,.ie7 .col-xl-3,.ie8 .col-xl-3{width:220px;width:13.75rem}.row .col-xl-3{margin-left:2.08333%;float:left}.ie6 .row .col-xl-3,.ie7 .row .col-xl-3,.ie8 .row .col-xl-3,.row.static .col-xl-3{margin-left:1.25rem}.col-xl-4{width:300px;width:31.25%;max-width:300px;max-width:18.75rem}.col-xl-4.static,.ie6 .col-xl-4,.ie7 .col-xl-4,.ie8 .col-xl-4{width:300px;width:18.75rem}.row .col-xl-4{margin-left:2.08333%;float:left}.ie6 .row .col-xl-4,.ie7 .row .col-xl-4,.ie8 .row .col-xl-4,.row.static .col-xl-4{margin-left:1.25rem}.col-xl-5{width:380px;width:39.58333%;max-width:380px;max-width:23.75rem}.col-xl-5.static,.ie6 .col-xl-5,.ie7 .col-xl-5,.ie8 .col-xl-5{width:380px;width:23.75rem}.row .col-xl-5{margin-left:2.08333%;float:left}.ie6 .row .col-xl-5,.ie7 .row .col-xl-5,.ie8 .row .col-xl-5,.row.static .col-xl-5{margin-left:1.25rem}.col-xl-6{width:460px;width:47.91667%;max-width:460px;max-width:28.75rem}.col-xl-6.static,.ie6 .col-xl-6,.ie7 .col-xl-6,.ie8 .col-xl-6{width:460px;width:28.75rem}.row .col-xl-6{margin-left:2.08333%;float:left}.ie6 .row .col-xl-6,.ie7 .row .col-xl-6,.ie8 .row .col-xl-6,.row.static .col-xl-6{margin-left:1.25rem}.col-xl-7{width:540px;width:56.25%;max-width:540px;max-width:33.75rem}.col-xl-7.static,.ie6 .col-xl-7,.ie7 .col-xl-7,.ie8 .col-xl-7{width:540px;width:33.75rem}.row .col-xl-7{margin-left:2.08333%;float:left}.ie6 .row .col-xl-7,.ie7 .row .col-xl-7,.ie8 .row .col-xl-7,.row.static .col-xl-7{margin-left:1.25rem}.col-xl-8{width:620px;width:64.58333%;max-width:620px;max-width:38.75rem}.col-xl-8.static,.ie6 .col-xl-8,.ie7 .col-xl-8,.ie8 .col-xl-8{width:620px;width:38.75rem}.row .col-xl-8{margin-left:2.08333%;float:left}.ie6 .row .col-xl-8,.ie7 .row .col-xl-8,.ie8 .row .col-xl-8,.row.static .col-xl-8{margin-left:1.25rem}.col-xl-9{width:700px;width:72.91667%;max-width:700px;max-width:43.75rem}.col-xl-9.static,.ie6 .col-xl-9,.ie7 .col-xl-9,.ie8 .col-xl-9{width:700px;width:43.75rem}.row .col-xl-9{margin-left:2.08333%;float:left}.ie6 .row .col-xl-9,.ie7 .row .col-xl-9,.ie8 .row .col-xl-9,.row.static .col-xl-9{margin-left:1.25rem}.col-xl-10{width:780px;width:81.25%;max-width:780px;max-width:48.75rem}.col-xl-10.static,.ie6 .col-xl-10,.ie7 .col-xl-10,.ie8 .col-xl-10{width:780px;width:48.75rem}.row .col-xl-10{margin-left:2.08333%;float:left}.ie6 .row .col-xl-10,.ie7 .row .col-xl-10,.ie8 .row .col-xl-10,.row.static .col-xl-10{margin-left:1.25rem}.col-xl-11{width:860px;width:89.58333%;max-width:860px;max-width:53.75rem}.col-xl-11.static,.ie6 .col-xl-11,.ie7 .col-xl-11,.ie8 .col-xl-11{width:860px;width:53.75rem}.row .col-xl-11{margin-left:2.08333%;float:left}.ie6 .row .col-xl-11,.ie7 .row .col-xl-11,.ie8 .row .col-xl-11,.row.static .col-xl-11{margin-left:1.25rem}.col-xl-12{width:940px;width:97.91667%;max-width:940px;max-width:58.75rem}.col-xl-12.static,.ie6 .col-xl-12,.ie7 .col-xl-12,.ie8 .col-xl-12{width:940px;width:58.75rem}.row .col-xl-12{margin-left:2.08333%;float:left}.ie6 .row .col-xl-12,.ie7 .row .col-xl-12,.ie8 .row .col-xl-12,.row.static .col-xl-12{margin-left:1.25rem}.hidden-xl{display:none}.visible-xl{display:block}@media screen and (max-width:20em){body:before{position:absolute;content:\"xs\";visibility:hidden;text-indent:-99999px;height:0;width:0}.grid-width{max-width:20rem;width:100%}.col.full{width:300px;width:93.75%;max-width:300px;max-width:18.75rem;margin-right:3.125%;margin-left:3.125%}.col-xs-full{width:100%}.col-xs-full.static{width:300px;width:18.75rem}.row .col-xs-full{margin-left:6.25%;float:left}.row .col-xs-full.static{margin-left:1.25rem}.col-xs-half{width:140px;width:43.75%;max-width:140px;max-width:8.75rem}.col-xs-half.static{width:140px;width:8.75rem}.row .col-xs-half{margin-left:6.25%;float:left}.row .col-xs-half.static{margin-left:1.25rem}.col-xs-third{width:86.66667px;width:27.08333%;max-width:86.66667px;max-width:5.41667rem}.col-xs-third.static{width:86.66667px;width:5.41667rem}.row .col-xs-third{margin-left:6.25%;float:left}.row .col-xs-third.static{margin-left:1.25rem}.col-xs-fourth{width:60px;width:18.75%;max-width:60px;max-width:3.75rem}.col-xs-fourth.static{width:60px;width:3.75rem}.row .col-xs-fourth{margin-left:6.25%;float:left}.row .col-xs-fourth.static{margin-left:1.25rem}.col-xs-fifth{width:44px;width:13.75%;max-width:44px;max-width:2.75rem}.col-xs-fifth.static{width:44px;width:2.75rem}.row .col-xs-fifth{margin-left:6.25%;float:left}.row .col-xs-fifth.static{margin-left:1.25rem}.col-xs-sixth{width:33.33333px;width:10.41667%;max-width:33.33333px;max-width:2.08333rem}.col-xs-sixth.static{width:33.33333px;width:2.08333rem}.row .col-xs-sixth{margin-left:6.25%;float:left}.row .col-xs-sixth.static{margin-left:1.25rem}.col-xs-seventh{width:25.71429px;width:8.03571%;max-width:25.71429px;max-width:1.60714rem}.col-xs-seventh.static{width:25.71429px;width:1.60714rem}.row .col-xs-seventh{margin-left:6.25%;float:left}.row .col-xs-seventh.static{margin-left:1.25rem}.col-xs-eighth{width:20px;width:6.25%;max-width:20px;max-width:1.25rem}.col-xs-eighth.static{width:20px;width:1.25rem}.row .col-xs-eighth{margin-left:6.25%;float:left}.row .col-xs-eighth.static{margin-left:1.25rem}.col-xs-ninth{width:15.55556px;width:4.86111%;max-width:15.55556px;max-width:.97222rem}.col-xs-ninth.static{width:15.55556px;width:.97222rem}.row .col-xs-ninth{margin-left:6.25%;float:left}.row .col-xs-ninth.static{margin-left:1.25rem}.col-xs-tenth{width:12px;width:3.75%;max-width:12px;max-width:.75rem}.col-xs-tenth.static{width:12px;width:.75rem}.row .col-xs-tenth{margin-left:6.25%;float:left}.row .col-xs-tenth.static{margin-left:1.25rem}.row{margin-left:-6.25%}.row .col{margin-left:6.25%;float:left}.ie6 .row,.ie7 .row,.ie8 .row,.row.static{width:auto;margin-left:-1.25rem}.ie6 .row .col,.ie7 .row .col,.ie8 .row .col,.row.static .col{margin-left:1.25rem;float:left}.row:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.col-xs-1{width:60px;width:18.75%;max-width:60px;max-width:3.75rem}.col-xs-1.static,.ie6 .col-xs-1,.ie7 .col-xs-1,.ie8 .col-xs-1{width:60px;width:3.75rem}.row .col-xs-1{margin-left:6.25%;float:left}.ie6 .row .col-xs-1,.ie7 .row .col-xs-1,.ie8 .row .col-xs-1,.row.static .col-xs-1{margin-left:1.25rem}.col-xs-2{width:140px;width:43.75%;max-width:140px;max-width:8.75rem}.col-xs-2.static,.ie6 .col-xs-2,.ie7 .col-xs-2,.ie8 .col-xs-2{width:140px;width:8.75rem}.row .col-xs-2{margin-left:6.25%;float:left}.ie6 .row .col-xs-2,.ie7 .row .col-xs-2,.ie8 .row .col-xs-2,.row.static .col-xs-2{margin-left:1.25rem}.col-xs-3{width:220px;width:68.75%;max-width:220px;max-width:13.75rem}.col-xs-3.static,.ie6 .col-xs-3,.ie7 .col-xs-3,.ie8 .col-xs-3{width:220px;width:13.75rem}.row .col-xs-3{margin-left:6.25%;float:left}.ie6 .row .col-xs-3,.ie7 .row .col-xs-3,.ie8 .row .col-xs-3,.row.static .col-xs-3{margin-left:1.25rem}.col-xs-4{width:300px;width:93.75%;max-width:300px;max-width:18.75rem}.col-xs-4.static,.ie6 .col-xs-4,.ie7 .col-xs-4,.ie8 .col-xs-4{width:300px;width:18.75rem}.row .col-xs-4{margin-left:6.25%;float:left}.ie6 .row .col-xs-4,.ie7 .row .col-xs-4,.ie8 .row .col-xs-4,.row.static .col-xs-4{margin-left:1.25rem}.hidden-xs{display:none}.visible-xs{display:block}}@media screen and (min-width:20em){body:before{position:absolute;content:\"sm\";visibility:hidden;text-indent:-99999px;height:0;width:0}.grid-width{max-width:40rem;width:100%}.col.full{width:620px;width:96.875%;max-width:620px;max-width:38.75rem;margin-right:1.5625%;margin-left:1.5625%}.col-sm-full{width:100%}.col-sm-full.static{width:620px;width:38.75rem}.row .col-sm-full{margin-left:3.125%;float:left}.row .col-sm-full.static{margin-left:1.25rem}.col-sm-half{width:300px;width:46.875%;max-width:300px;max-width:18.75rem}.col-sm-half.static{width:300px;width:18.75rem}.row .col-sm-half{margin-left:3.125%;float:left}.row .col-sm-half.static{margin-left:1.25rem}.col-sm-third{width:193.33333px;width:30.20833%;max-width:193.33333px;max-width:12.08333rem}.col-sm-third.static{width:193.33333px;width:12.08333rem}.row .col-sm-third{margin-left:3.125%;float:left}.row .col-sm-third.static{margin-left:1.25rem}.col-sm-fourth{width:140px;width:21.875%;max-width:140px;max-width:8.75rem}.col-sm-fourth.static{width:140px;width:8.75rem}.row .col-sm-fourth{margin-left:3.125%;float:left}.row .col-sm-fourth.static{margin-left:1.25rem}.col-sm-fifth{width:108px;width:16.875%;max-width:108px;max-width:6.75rem}.col-sm-fifth.static{width:108px;width:6.75rem}.row .col-sm-fifth{margin-left:3.125%;float:left}.row .col-sm-fifth.static{margin-left:1.25rem}.col-sm-sixth{width:86.66667px;width:13.54167%;max-width:86.66667px;max-width:5.41667rem}.col-sm-sixth.static{width:86.66667px;width:5.41667rem}.row .col-sm-sixth{margin-left:3.125%;float:left}.row .col-sm-sixth.static{margin-left:1.25rem}.col-sm-seventh{width:71.42857px;width:11.16071%;max-width:71.42857px;max-width:4.46429rem}.col-sm-seventh.static{width:71.42857px;width:4.46429rem}.row .col-sm-seventh{margin-left:3.125%;float:left}.row .col-sm-seventh.static{margin-left:1.25rem}.col-sm-eighth{width:60px;width:9.375%;max-width:60px;max-width:3.75rem}.col-sm-eighth.static{width:60px;width:3.75rem}.row .col-sm-eighth{margin-left:3.125%;float:left}.row .col-sm-eighth.static{margin-left:1.25rem}.col-sm-ninth{width:51.11111px;width:7.98611%;max-width:51.11111px;max-width:3.19444rem}.col-sm-ninth.static{width:51.11111px;width:3.19444rem}.row .col-sm-ninth{margin-left:3.125%;float:left}.row .col-sm-ninth.static{margin-left:1.25rem}.col-sm-tenth{width:44px;width:6.875%;max-width:44px;max-width:2.75rem}.col-sm-tenth.static{width:44px;width:2.75rem}.row .col-sm-tenth{margin-left:3.125%;float:left}.row .col-sm-tenth.static{margin-left:1.25rem}.row{margin-left:-3.125%}.row .col{margin-left:3.125%;float:left}.ie6 .row,.ie7 .row,.ie8 .row,.row.static{width:auto;margin-left:-1.25rem}.ie6 .row .col,.ie7 .row .col,.ie8 .row .col,.row.static .col{margin-left:1.25rem;float:left}.row:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.col-sm-1{width:60px;width:9.375%;max-width:60px;max-width:3.75rem}.col-sm-1.static,.ie6 .col-sm-1,.ie7 .col-sm-1,.ie8 .col-sm-1{width:60px;width:3.75rem}.row .col-sm-1{margin-left:3.125%;float:left}.ie6 .row .col-sm-1,.ie7 .row .col-sm-1,.ie8 .row .col-sm-1,.row.static .col-sm-1{margin-left:1.25rem}.col-sm-2{width:140px;width:21.875%;max-width:140px;max-width:8.75rem}.col-sm-2.static,.ie6 .col-sm-2,.ie7 .col-sm-2,.ie8 .col-sm-2{width:140px;width:8.75rem}.row .col-sm-2{margin-left:3.125%;float:left}.ie6 .row .col-sm-2,.ie7 .row .col-sm-2,.ie8 .row .col-sm-2,.row.static .col-sm-2{margin-left:1.25rem}.col-sm-3{width:220px;width:34.375%;max-width:220px;max-width:13.75rem}.col-sm-3.static,.ie6 .col-sm-3,.ie7 .col-sm-3,.ie8 .col-sm-3{width:220px;width:13.75rem}.row .col-sm-3{margin-left:3.125%;float:left}.ie6 .row .col-sm-3,.ie7 .row .col-sm-3,.ie8 .row .col-sm-3,.row.static .col-sm-3{margin-left:1.25rem}.col-sm-4{width:300px;width:46.875%;max-width:300px;max-width:18.75rem}.col-sm-4.static,.ie6 .col-sm-4,.ie7 .col-sm-4,.ie8 .col-sm-4{width:300px;width:18.75rem}.row .col-sm-4{margin-left:3.125%;float:left}.ie6 .row .col-sm-4,.ie7 .row .col-sm-4,.ie8 .row .col-sm-4,.row.static .col-sm-4{margin-left:1.25rem}.col-sm-5{width:380px;width:59.375%;max-width:380px;max-width:23.75rem}.col-sm-5.static,.ie6 .col-sm-5,.ie7 .col-sm-5,.ie8 .col-sm-5{width:380px;width:23.75rem}.row .col-sm-5{margin-left:3.125%;float:left}.ie6 .row .col-sm-5,.ie7 .row .col-sm-5,.ie8 .row .col-sm-5,.row.static .col-sm-5{margin-left:1.25rem}.col-sm-6{width:460px;width:71.875%;max-width:460px;max-width:28.75rem}.col-sm-6.static,.ie6 .col-sm-6,.ie7 .col-sm-6,.ie8 .col-sm-6{width:460px;width:28.75rem}.row .col-sm-6{margin-left:3.125%;float:left}.ie6 .row .col-sm-6,.ie7 .row .col-sm-6,.ie8 .row .col-sm-6,.row.static .col-sm-6{margin-left:1.25rem}.col-sm-7{width:540px;width:84.375%;max-width:540px;max-width:33.75rem}.col-sm-7.static,.ie6 .col-sm-7,.ie7 .col-sm-7,.ie8 .col-sm-7{width:540px;width:33.75rem}.row .col-sm-7{margin-left:3.125%;float:left}.ie6 .row .col-sm-7,.ie7 .row .col-sm-7,.ie8 .row .col-sm-7,.row.static .col-sm-7{margin-left:1.25rem}.col-sm-8{width:620px;width:96.875%;max-width:620px;max-width:38.75rem}.col-sm-8.static,.ie6 .col-sm-8,.ie7 .col-sm-8,.ie8 .col-sm-8{width:620px;width:38.75rem}.row .col-sm-8{margin-left:3.125%;float:left}.ie6 .row .col-sm-8,.ie7 .row .col-sm-8,.ie8 .row .col-sm-8,.row.static .col-sm-8{margin-left:1.25rem}.hidden-sm{display:none}.visible-sm{display:block}}@media screen and (min-width:30em){body:before{position:absolute;content:\"md\";visibility:hidden;text-indent:-99999px;height:0;width:0}.grid-width{max-width:50rem;width:100%}.col.full{width:780px;width:97.5%;max-width:780px;max-width:48.75rem;margin-right:1.25%;margin-left:1.25%}.col-md-full{width:100%}.col-md-full.static{width:780px;width:48.75rem}.row .col-md-full{margin-left:2.5%;float:left}.row .col-md-full.static{margin-left:1.25rem}.col-md-half{width:380px;width:47.5%;max-width:380px;max-width:23.75rem}.col-md-half.static{width:380px;width:23.75rem}.row .col-md-half{margin-left:2.5%;float:left}.row .col-md-half.static{margin-left:1.25rem}.col-md-third{width:246.66667px;width:30.83333%;max-width:246.66667px;max-width:15.41667rem}.col-md-third.static{width:246.66667px;width:15.41667rem}.row .col-md-third{margin-left:2.5%;float:left}.row .col-md-third.static{margin-left:1.25rem}.col-md-fourth{width:180px;width:22.5%;max-width:180px;max-width:11.25rem}.col-md-fourth.static{width:180px;width:11.25rem}.row .col-md-fourth{margin-left:2.5%;float:left}.row .col-md-fourth.static{margin-left:1.25rem}.col-md-fifth{width:140px;width:17.5%;max-width:140px;max-width:8.75rem}.col-md-fifth.static{width:140px;width:8.75rem}.row .col-md-fifth{margin-left:2.5%;float:left}.row .col-md-fifth.static{margin-left:1.25rem}.col-md-sixth{width:113.33333px;width:14.16667%;max-width:113.33333px;max-width:7.08333rem}.col-md-sixth.static{width:113.33333px;width:7.08333rem}.row .col-md-sixth{margin-left:2.5%;float:left}.row .col-md-sixth.static{margin-left:1.25rem}.col-md-seventh{width:94.28571px;width:11.78571%;max-width:94.28571px;max-width:5.89286rem}.col-md-seventh.static{width:94.28571px;width:5.89286rem}.row .col-md-seventh{margin-left:2.5%;float:left}.row .col-md-seventh.static{margin-left:1.25rem}.col-md-eighth{width:80px;width:10%;max-width:80px;max-width:5rem}.col-md-eighth.static{width:80px;width:5rem}.row .col-md-eighth{margin-left:2.5%;float:left}.row .col-md-eighth.static{margin-left:1.25rem}.col-md-ninth{width:68.88889px;width:8.61111%;max-width:68.88889px;max-width:4.30556rem}.col-md-ninth.static{width:68.88889px;width:4.30556rem}.row .col-md-ninth{margin-left:2.5%;float:left}.row .col-md-ninth.static{margin-left:1.25rem}.col-md-tenth{width:60px;width:7.5%;max-width:60px;max-width:3.75rem}.col-md-tenth.static{width:60px;width:3.75rem}.row .col-md-tenth{margin-left:2.5%;float:left}.row .col-md-tenth.static{margin-left:1.25rem}.row{margin-left:-2.5%}.row .col{margin-left:2.5%;float:left}.ie6 .row,.ie7 .row,.ie8 .row,.row.static{width:auto;margin-left:-1.25rem}.ie6 .row .col,.ie7 .row .col,.ie8 .row .col,.row.static .col{margin-left:1.25rem;float:left}.row:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.col-md-1{width:60px;width:7.5%;max-width:60px;max-width:3.75rem}.col-md-1.static,.ie6 .col-md-1,.ie7 .col-md-1,.ie8 .col-md-1{width:60px;width:3.75rem}.row .col-md-1{margin-left:2.5%;float:left}.ie6 .row .col-md-1,.ie7 .row .col-md-1,.ie8 .row .col-md-1,.row.static .col-md-1{margin-left:1.25rem}.col-md-2{width:140px;width:17.5%;max-width:140px;max-width:8.75rem}.col-md-2.static,.ie6 .col-md-2,.ie7 .col-md-2,.ie8 .col-md-2{width:140px;width:8.75rem}.row .col-md-2{margin-left:2.5%;float:left}.ie6 .row .col-md-2,.ie7 .row .col-md-2,.ie8 .row .col-md-2,.row.static .col-md-2{margin-left:1.25rem}.col-md-3{width:220px;width:27.5%;max-width:220px;max-width:13.75rem}.col-md-3.static,.ie6 .col-md-3,.ie7 .col-md-3,.ie8 .col-md-3{width:220px;width:13.75rem}.row .col-md-3{margin-left:2.5%;float:left}.ie6 .row .col-md-3,.ie7 .row .col-md-3,.ie8 .row .col-md-3,.row.static .col-md-3{margin-left:1.25rem}.col-md-4{width:300px;width:37.5%;max-width:300px;max-width:18.75rem}.col-md-4.static,.ie6 .col-md-4,.ie7 .col-md-4,.ie8 .col-md-4{width:300px;width:18.75rem}.row .col-md-4{margin-left:2.5%;float:left}.ie6 .row .col-md-4,.ie7 .row .col-md-4,.ie8 .row .col-md-4,.row.static .col-md-4{margin-left:1.25rem}.col-md-5{width:380px;width:47.5%;max-width:380px;max-width:23.75rem}.col-md-5.static,.ie6 .col-md-5,.ie7 .col-md-5,.ie8 .col-md-5{width:380px;width:23.75rem}.row .col-md-5{margin-left:2.5%;float:left}.ie6 .row .col-md-5,.ie7 .row .col-md-5,.ie8 .row .col-md-5,.row.static .col-md-5{margin-left:1.25rem}.col-md-6{width:460px;width:57.5%;max-width:460px;max-width:28.75rem}.col-md-6.static,.ie6 .col-md-6,.ie7 .col-md-6,.ie8 .col-md-6{width:460px;width:28.75rem}.row .col-md-6{margin-left:2.5%;float:left}.ie6 .row .col-md-6,.ie7 .row .col-md-6,.ie8 .row .col-md-6,.row.static .col-md-6{margin-left:1.25rem}.col-md-7{width:540px;width:67.5%;max-width:540px;max-width:33.75rem}.col-md-7.static,.ie6 .col-md-7,.ie7 .col-md-7,.ie8 .col-md-7{width:540px;width:33.75rem}.row .col-md-7{margin-left:2.5%;float:left}.ie6 .row .col-md-7,.ie7 .row .col-md-7,.ie8 .row .col-md-7,.row.static .col-md-7{margin-left:1.25rem}.col-md-8{width:620px;width:77.5%;max-width:620px;max-width:38.75rem}.col-md-8.static,.ie6 .col-md-8,.ie7 .col-md-8,.ie8 .col-md-8{width:620px;width:38.75rem}.row .col-md-8{margin-left:2.5%;float:left}.ie6 .row .col-md-8,.ie7 .row .col-md-8,.ie8 .row .col-md-8,.row.static .col-md-8{margin-left:1.25rem}.col-md-9{width:700px;width:87.5%;max-width:700px;max-width:43.75rem}.col-md-9.static,.ie6 .col-md-9,.ie7 .col-md-9,.ie8 .col-md-9{width:700px;width:43.75rem}.row .col-md-9{margin-left:2.5%;float:left}.ie6 .row .col-md-9,.ie7 .row .col-md-9,.ie8 .row .col-md-9,.row.static .col-md-9{margin-left:1.25rem}.col-md-10{width:780px;width:97.5%;max-width:780px;max-width:48.75rem}.col-md-10.static,.ie6 .col-md-10,.ie7 .col-md-10,.ie8 .col-md-10{width:780px;width:48.75rem}.row .col-md-10{margin-left:2.5%;float:left}.ie6 .row .col-md-10,.ie7 .row .col-md-10,.ie8 .row .col-md-10,.row.static .col-md-10{margin-left:1.25rem}.hidden-md{display:none}.visible-md{display:block}}@media screen and (min-width:48em){body:before{position:absolute;content:\"lg\";visibility:hidden;text-indent:-99999px;height:0;width:0}.grid-width{max-width:60rem;width:100%}.col.full{width:940px;width:97.91667%;max-width:940px;max-width:58.75rem;margin-right:1.04167%;margin-left:1.04167%}.col-lg-full{width:100%}.col-lg-full.static{width:940px;width:58.75rem}.row .col-lg-full{margin-left:2.08333%;float:left}.row .col-lg-full.static{margin-left:1.25rem}.col-lg-half{width:460px;width:47.91667%;max-width:460px;max-width:28.75rem}.col-lg-half.static{width:460px;width:28.75rem}.row .col-lg-half{margin-left:2.08333%;float:left}.row .col-lg-half.static{margin-left:1.25rem}.col-lg-third{width:300px;width:31.25%;max-width:300px;max-width:18.75rem}.col-lg-third.static{width:300px;width:18.75rem}.row .col-lg-third{margin-left:2.08333%;float:left}.row .col-lg-third.static{margin-left:1.25rem}.col-lg-fourth{width:220px;width:22.91667%;max-width:220px;max-width:13.75rem}.col-lg-fourth.static{width:220px;width:13.75rem}.row .col-lg-fourth{margin-left:2.08333%;float:left}.row .col-lg-fourth.static{margin-left:1.25rem}.col-lg-fifth{width:172px;width:17.91667%;max-width:172px;max-width:10.75rem}.col-lg-fifth.static{width:172px;width:10.75rem}.row .col-lg-fifth{margin-left:2.08333%;float:left}.row .col-lg-fifth.static{margin-left:1.25rem}.col-lg-sixth{width:140px;width:14.58333%;max-width:140px;max-width:8.75rem}.col-lg-sixth.static{width:140px;width:8.75rem}.row .col-lg-sixth{margin-left:2.08333%;float:left}.row .col-lg-sixth.static{margin-left:1.25rem}.col-lg-seventh{width:117.14286px;width:12.20238%;max-width:117.14286px;max-width:7.32143rem}.col-lg-seventh.static{width:117.14286px;width:7.32143rem}.row .col-lg-seventh{margin-left:2.08333%;float:left}.row .col-lg-seventh.static{margin-left:1.25rem}.col-lg-eighth{width:100px;width:10.41667%;max-width:100px;max-width:6.25rem}.col-lg-eighth.static{width:100px;width:6.25rem}.row .col-lg-eighth{margin-left:2.08333%;float:left}.row .col-lg-eighth.static{margin-left:1.25rem}.col-lg-ninth{width:86.66667px;width:9.02778%;max-width:86.66667px;max-width:5.41667rem}.col-lg-ninth.static{width:86.66667px;width:5.41667rem}.row .col-lg-ninth{margin-left:2.08333%;float:left}.row .col-lg-ninth.static{margin-left:1.25rem}.col-lg-tenth{width:76px;width:7.91667%;max-width:76px;max-width:4.75rem}.col-lg-tenth.static{width:76px;width:4.75rem}.row .col-lg-tenth{margin-left:2.08333%;float:left}.row .col-lg-tenth.static{margin-left:1.25rem}.row{margin-left:-2.08333%}.row .col{margin-left:2.08333%;float:left}.ie6 .row,.ie7 .row,.ie8 .row,.row.static{width:auto;margin-left:-1.25rem}.ie6 .row .col,.ie7 .row .col,.ie8 .row .col,.row.static .col{margin-left:1.25rem;float:left}.row:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.col-lg-1{width:60px;width:6.25%;max-width:60px;max-width:3.75rem}.col-lg-1.static,.ie6 .col-lg-1,.ie7 .col-lg-1,.ie8 .col-lg-1{width:60px;width:3.75rem}.row .col-lg-1{margin-left:2.08333%;float:left}.ie6 .row .col-lg-1,.ie7 .row .col-lg-1,.ie8 .row .col-lg-1,.row.static .col-lg-1{margin-left:1.25rem}.col-lg-2{width:140px;width:14.58333%;max-width:140px;max-width:8.75rem}.col-lg-2.static,.ie6 .col-lg-2,.ie7 .col-lg-2,.ie8 .col-lg-2{width:140px;width:8.75rem}.row .col-lg-2{margin-left:2.08333%;float:left}.ie6 .row .col-lg-2,.ie7 .row .col-lg-2,.ie8 .row .col-lg-2,.row.static .col-lg-2{margin-left:1.25rem}.col-lg-3{width:220px;width:22.91667%;max-width:220px;max-width:13.75rem}.col-lg-3.static,.ie6 .col-lg-3,.ie7 .col-lg-3,.ie8 .col-lg-3{width:220px;width:13.75rem}.row .col-lg-3{margin-left:2.08333%;float:left}.ie6 .row .col-lg-3,.ie7 .row .col-lg-3,.ie8 .row .col-lg-3,.row.static .col-lg-3{margin-left:1.25rem}.col-lg-4{width:300px;width:31.25%;max-width:300px;max-width:18.75rem}.col-lg-4.static,.ie6 .col-lg-4,.ie7 .col-lg-4,.ie8 .col-lg-4{width:300px;width:18.75rem}.row .col-lg-4{margin-left:2.08333%;float:left}.ie6 .row .col-lg-4,.ie7 .row .col-lg-4,.ie8 .row .col-lg-4,.row.static .col-lg-4{margin-left:1.25rem}.col-lg-5{width:380px;width:39.58333%;max-width:380px;max-width:23.75rem}.col-lg-5.static,.ie6 .col-lg-5,.ie7 .col-lg-5,.ie8 .col-lg-5{width:380px;width:23.75rem}.row .col-lg-5{margin-left:2.08333%;float:left}.ie6 .row .col-lg-5,.ie7 .row .col-lg-5,.ie8 .row .col-lg-5,.row.static .col-lg-5{margin-left:1.25rem}.col-lg-6{width:460px;width:47.91667%;max-width:460px;max-width:28.75rem}.col-lg-6.static,.ie6 .col-lg-6,.ie7 .col-lg-6,.ie8 .col-lg-6{width:460px;width:28.75rem}.row .col-lg-6{margin-left:2.08333%;float:left}.ie6 .row .col-lg-6,.ie7 .row .col-lg-6,.ie8 .row .col-lg-6,.row.static .col-lg-6{margin-left:1.25rem}.col-lg-7{width:540px;width:56.25%;max-width:540px;max-width:33.75rem}.col-lg-7.static,.ie6 .col-lg-7,.ie7 .col-lg-7,.ie8 .col-lg-7{width:540px;width:33.75rem}.row .col-lg-7{margin-left:2.08333%;float:left}.ie6 .row .col-lg-7,.ie7 .row .col-lg-7,.ie8 .row .col-lg-7,.row.static .col-lg-7{margin-left:1.25rem}.col-lg-8{width:620px;width:64.58333%;max-width:620px;max-width:38.75rem}.col-lg-8.static,.ie6 .col-lg-8,.ie7 .col-lg-8,.ie8 .col-lg-8{width:620px;width:38.75rem}.row .col-lg-8{margin-left:2.08333%;float:left}.ie6 .row .col-lg-8,.ie7 .row .col-lg-8,.ie8 .row .col-lg-8,.row.static .col-lg-8{margin-left:1.25rem}.col-lg-9{width:700px;width:72.91667%;max-width:700px;max-width:43.75rem}.col-lg-9.static,.ie6 .col-lg-9,.ie7 .col-lg-9,.ie8 .col-lg-9{width:700px;width:43.75rem}.row .col-lg-9{margin-left:2.08333%;float:left}.ie6 .row .col-lg-9,.ie7 .row .col-lg-9,.ie8 .row .col-lg-9,.row.static .col-lg-9{margin-left:1.25rem}.col-lg-10{width:780px;width:81.25%;max-width:780px;max-width:48.75rem}.col-lg-10.static,.ie6 .col-lg-10,.ie7 .col-lg-10,.ie8 .col-lg-10{width:780px;width:48.75rem}.row .col-lg-10{margin-left:2.08333%;float:left}.ie6 .row .col-lg-10,.ie7 .row .col-lg-10,.ie8 .row .col-lg-10,.row.static .col-lg-10{margin-left:1.25rem}.col-lg-11{width:860px;width:89.58333%;max-width:860px;max-width:53.75rem}.col-lg-11.static,.ie6 .col-lg-11,.ie7 .col-lg-11,.ie8 .col-lg-11{width:860px;width:53.75rem}.row .col-lg-11{margin-left:2.08333%;float:left}.ie6 .row .col-lg-11,.ie7 .row .col-lg-11,.ie8 .row .col-lg-11,.row.static .col-lg-11{margin-left:1.25rem}.col-lg-12{width:940px;width:97.91667%;max-width:940px;max-width:58.75rem}.col-lg-12.static,.ie6 .col-lg-12,.ie7 .col-lg-12,.ie8 .col-lg-12{width:940px;width:58.75rem}.row .col-lg-12{margin-left:2.08333%;float:left}.ie6 .row .col-lg-12,.ie7 .row .col-lg-12,.ie8 .row .col-lg-12,.row.static .col-lg-12{margin-left:1.25rem}.hidden-lg{display:none}.visible-lg{display:block}}@media screen and (min-width:60em){body:before{position:absolute;content:\"xl\";visibility:hidden;text-indent:-99999px;height:0;width:0}.grid-width{max-width:60rem;width:100%}.col.full{width:940px;width:97.91667%;max-width:940px;max-width:58.75rem;margin-right:1.04167%;margin-left:1.04167%}.col-xl-full{width:100%}.col-xl-full.static{width:940px;width:58.75rem}.row .col-xl-full{margin-left:2.08333%;float:left}.row .col-xl-full.static{margin-left:1.25rem}.col-xl-half{width:460px;width:47.91667%;max-width:460px;max-width:28.75rem}.col-xl-half.static{width:460px;width:28.75rem}.row .col-xl-half{margin-left:2.08333%;float:left}.row .col-xl-half.static{margin-left:1.25rem}.col-xl-third{width:300px;width:31.25%;max-width:300px;max-width:18.75rem}.col-xl-third.static{width:300px;width:18.75rem}.row .col-xl-third{margin-left:2.08333%;float:left}.row .col-xl-third.static{margin-left:1.25rem}.col-xl-fourth{width:220px;width:22.91667%;max-width:220px;max-width:13.75rem}.col-xl-fourth.static{width:220px;width:13.75rem}.row .col-xl-fourth{margin-left:2.08333%;float:left}.row .col-xl-fourth.static{margin-left:1.25rem}.col-xl-fifth{width:172px;width:17.91667%;max-width:172px;max-width:10.75rem}.col-xl-fifth.static{width:172px;width:10.75rem}.row .col-xl-fifth{margin-left:2.08333%;float:left}.row .col-xl-fifth.static{margin-left:1.25rem}.col-xl-sixth{width:140px;width:14.58333%;max-width:140px;max-width:8.75rem}.col-xl-sixth.static{width:140px;width:8.75rem}.row .col-xl-sixth{margin-left:2.08333%;float:left}.row .col-xl-sixth.static{margin-left:1.25rem}.col-xl-seventh{width:117.14286px;width:12.20238%;max-width:117.14286px;max-width:7.32143rem}.col-xl-seventh.static{width:117.14286px;width:7.32143rem}.row .col-xl-seventh{margin-left:2.08333%;float:left}.row .col-xl-seventh.static{margin-left:1.25rem}.col-xl-eighth{width:100px;width:10.41667%;max-width:100px;max-width:6.25rem}.col-xl-eighth.static{width:100px;width:6.25rem}.row .col-xl-eighth{margin-left:2.08333%;float:left}.row .col-xl-eighth.static{margin-left:1.25rem}.col-xl-ninth{width:86.66667px;width:9.02778%;max-width:86.66667px;max-width:5.41667rem}.col-xl-ninth.static{width:86.66667px;width:5.41667rem}.row .col-xl-ninth{margin-left:2.08333%;float:left}.row .col-xl-ninth.static{margin-left:1.25rem}.col-xl-tenth{width:76px;width:7.91667%;max-width:76px;max-width:4.75rem}.col-xl-tenth.static{width:76px;width:4.75rem}.row .col-xl-tenth{margin-left:2.08333%;float:left}.row .col-xl-tenth.static{margin-left:1.25rem}.row{margin-left:-2.08333%}.row .col{margin-left:2.08333%;float:left}.ie6 .row,.ie7 .row,.ie8 .row,.row.static{width:auto;margin-left:-1.25rem}.ie6 .row .col,.ie7 .row .col,.ie8 .row .col,.row.static .col{margin-left:1.25rem;float:left}.row:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.col-xl-1{width:60px;width:6.25%;max-width:60px;max-width:3.75rem}.col-xl-1.static,.ie6 .col-xl-1,.ie7 .col-xl-1,.ie8 .col-xl-1{width:60px;width:3.75rem}.row .col-xl-1{margin-left:2.08333%;float:left}.ie6 .row .col-xl-1,.ie7 .row .col-xl-1,.ie8 .row .col-xl-1,.row.static .col-xl-1{margin-left:1.25rem}.col-xl-2{width:140px;width:14.58333%;max-width:140px;max-width:8.75rem}.col-xl-2.static,.ie6 .col-xl-2,.ie7 .col-xl-2,.ie8 .col-xl-2{width:140px;width:8.75rem}.row .col-xl-2{margin-left:2.08333%;float:left}.ie6 .row .col-xl-2,.ie7 .row .col-xl-2,.ie8 .row .col-xl-2,.row.static .col-xl-2{margin-left:1.25rem}.col-xl-3{width:220px;width:22.91667%;max-width:220px;max-width:13.75rem}.col-xl-3.static,.ie6 .col-xl-3,.ie7 .col-xl-3,.ie8 .col-xl-3{width:220px;width:13.75rem}.row .col-xl-3{margin-left:2.08333%;float:left}.ie6 .row .col-xl-3,.ie7 .row .col-xl-3,.ie8 .row .col-xl-3,.row.static .col-xl-3{margin-left:1.25rem}.col-xl-4{width:300px;width:31.25%;max-width:300px;max-width:18.75rem}.col-xl-4.static,.ie6 .col-xl-4,.ie7 .col-xl-4,.ie8 .col-xl-4{width:300px;width:18.75rem}.row .col-xl-4{margin-left:2.08333%;float:left}.ie6 .row .col-xl-4,.ie7 .row .col-xl-4,.ie8 .row .col-xl-4,.row.static .col-xl-4{margin-left:1.25rem}.col-xl-5{width:380px;width:39.58333%;max-width:380px;max-width:23.75rem}.col-xl-5.static,.ie6 .col-xl-5,.ie7 .col-xl-5,.ie8 .col-xl-5{width:380px;width:23.75rem}.row .col-xl-5{margin-left:2.08333%;float:left}.ie6 .row .col-xl-5,.ie7 .row .col-xl-5,.ie8 .row .col-xl-5,.row.static .col-xl-5{margin-left:1.25rem}.col-xl-6{width:460px;width:47.91667%;max-width:460px;max-width:28.75rem}.col-xl-6.static,.ie6 .col-xl-6,.ie7 .col-xl-6,.ie8 .col-xl-6{width:460px;width:28.75rem}.row .col-xl-6{margin-left:2.08333%;float:left}.ie6 .row .col-xl-6,.ie7 .row .col-xl-6,.ie8 .row .col-xl-6,.row.static .col-xl-6{margin-left:1.25rem}.col-xl-7{width:540px;width:56.25%;max-width:540px;max-width:33.75rem}.col-xl-7.static,.ie6 .col-xl-7,.ie7 .col-xl-7,.ie8 .col-xl-7{width:540px;width:33.75rem}.row .col-xl-7{margin-left:2.08333%;float:left}.ie6 .row .col-xl-7,.ie7 .row .col-xl-7,.ie8 .row .col-xl-7,.row.static .col-xl-7{margin-left:1.25rem}.col-xl-8{width:620px;width:64.58333%;max-width:620px;max-width:38.75rem}.col-xl-8.static,.ie6 .col-xl-8,.ie7 .col-xl-8,.ie8 .col-xl-8{width:620px;width:38.75rem}.row .col-xl-8{margin-left:2.08333%;float:left}.ie6 .row .col-xl-8,.ie7 .row .col-xl-8,.ie8 .row .col-xl-8,.row.static .col-xl-8{margin-left:1.25rem}.col-xl-9{width:700px;width:72.91667%;max-width:700px;max-width:43.75rem}.col-xl-9.static,.ie6 .col-xl-9,.ie7 .col-xl-9,.ie8 .col-xl-9{width:700px;width:43.75rem}.row .col-xl-9{margin-left:2.08333%;float:left}.ie6 .row .col-xl-9,.ie7 .row .col-xl-9,.ie8 .row .col-xl-9,.row.static .col-xl-9{margin-left:1.25rem}.col-xl-10{width:780px;width:81.25%;max-width:780px;max-width:48.75rem}.col-xl-10.static,.ie6 .col-xl-10,.ie7 .col-xl-10,.ie8 .col-xl-10{width:780px;width:48.75rem}.row .col-xl-10{margin-left:2.08333%;float:left}.ie6 .row .col-xl-10,.ie7 .row .col-xl-10,.ie8 .row .col-xl-10,.row.static .col-xl-10{margin-left:1.25rem}.col-xl-11{width:860px;width:89.58333%;max-width:860px;max-width:53.75rem}.col-xl-11.static,.ie6 .col-xl-11,.ie7 .col-xl-11,.ie8 .col-xl-11{width:860px;width:53.75rem}.row .col-xl-11{margin-left:2.08333%;float:left}.ie6 .row .col-xl-11,.ie7 .row .col-xl-11,.ie8 .row .col-xl-11,.row.static .col-xl-11{margin-left:1.25rem}.col-xl-12{width:940px;width:97.91667%;max-width:940px;max-width:58.75rem}.col-xl-12.static,.ie6 .col-xl-12,.ie7 .col-xl-12,.ie8 .col-xl-12{width:940px;width:58.75rem}.row .col-xl-12{margin-left:2.08333%;float:left}.ie6 .row .col-xl-12,.ie7 .row .col-xl-12,.ie8 .row .col-xl-12,.row.static .col-xl-12{margin-left:1.25rem}.hidden-xl{display:none}.visible-xl{display:block}}.cnn-interactive img{vertical-align:middle;max-width:100%;height:auto;width:100%}.cnn-interactive .cvp-video{position:relative;padding-bottom:56.25%;height:0}.cnn-interactive .cvp-video iframe,.cnn-interactive .cvp-video object,.cnn-interactive .cvp-video video{position:absolute;height:100%!important;width:100%!important;left:0;top:0}.cnn-interactive__paragraph{line-height:1.25em}.cnn-interactive__source{font-size:.75rem;text-align:right;color:#595959}.share-container{width:300px;position:relative;margin-left:-15px}.share-container .share-bar{width:auto;display:inline-block;float:none}.share-container .share-bar li.share-button{width:35px;height:35px;float:right;margin-left:15px;cursor:pointer;list-style-type:none;-webkit-transition:transform .5s ease 0s;transition:transform .5s ease 0s}.share-container .share-bar li.share-button.email{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/email.png\");background-size:35px 35px}.share-container .share-bar li.share-button.facebook{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/facebook.png\");background-size:35px 35px}.share-container .share-bar li.share-button.twitter{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/twitter.png\");background-size:35px 35px}.share-container .share-bar li.share-button:hover{transform:scale(1.2);-webkit-transform:scale(1.2)}@media screen and (min-width:30em){.share-container{width:300px;position:relative;margin-left:-15px;clear:both;margin-top:0}.share-container .share-bar{width:auto;display:inline-block;float:left;padding-bottom:15px}.share-container .share-bar li.share-button{width:35px;height:35px;float:right;margin-left:15px;cursor:pointer;list-style-type:none;-webkit-transition:transform .5s ease 0s;transition:transform .5s ease 0s}.share-container .share-bar li.share-button.email{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/email.png\");background-size:35px 35px}.share-container .share-bar li.share-button.facebook{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/facebook.png\");background-size:35px 35px}.share-container .share-bar li.share-button.twitter{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/twitter.png\");background-size:35px 35px}.share-container .share-bar li.share-button:hover{transform:scale(1.2);-webkit-transform:scale(1.2)}}@media screen and (min-width:48em){.share-container{width:300px;float:right;margin-left:0;margin-bottom:10px;margin-top:-60px}.share-container .share-bar{width:auto;display:inline-block;float:right}.share-container .share-bar li.share-button{width:35px;height:35px;float:right;margin-left:15px;cursor:pointer;list-style-type:none;-webkit-transition:transform .5s ease 0s;transition:transform .5s ease 0s}.share-container .share-bar li.share-button.email{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/email.png\");background-size:35px 35px}.share-container .share-bar li.share-button.facebook{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/facebook.png\");background-size:35px 35px}.share-container .share-bar li.share-button.twitter{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/twitter.png\");background-size:35px 35px}.share-container .share-bar li.share-button:hover{transform:scale(1.2);-webkit-transform:scale(1.2)}}.periodic-map{padding:10px;margin-bottom:30px}.periodic-map[data-eq-state~=periodic-map-size-3]{padding:20px}.periodic-map-heading{padding-bottom:1rem;font-size:.55em}[data-eq-state$=periodic-map-size-4] .periodic-map-heading{font-size:1em}[data-eq-state$=periodic-map-size-5] .periodic-map-heading{font-size:1.2em}.periodic-map--legend{margin-bottom:15px}.periodic-map--legend__item{display:inline-block;position:relative;vertical-align:middle;font-size:.9em;margin-right:15px;height:auto;width:auto}.periodic-map--legend__item:before{content:\" \";display:inline-block;border-radius:50%;vertical-align:middle;position:relative;margin-right:5px;height:.75em;width:.75em;top:-1px}.periodic-map--legend__item.bush:before{background-color:#c00}.periodic-map--legend__item.carson:before{background-color:#7f042a}.periodic-map--legend__item.christie:before{background-color:#b34452}.periodic-map--legend__item.cruz:before{background-color:#bf2a4b}.periodic-map--legend__item.fiorina:before{background-color:#c95b88}.periodic-map--legend__item.huckabee:before{background-color:#bd0d55}.periodic-map--legend__item.kasich:before{background-color:#5f4253}.periodic-map--legend__item.paul:before{background-color:#fb1b17}.periodic-map--legend__item.rubio:before{background-color:#7a537b}.periodic-map--legend__item.santorum:before{background-color:#ff4c49}.periodic-map--legend__item.trump:before{background-color:#fd5154}.periodic-map--legend__item.clinton:before{background-color:#419bf9}.periodic-map--legend__item.sanders:before{background-color:#03b9c5}.periodic-map--legend__item.other:before{background-color:#ff885b!important}.periodic-map--square{-webkit-transform:translate(0),rotate(.00001deg);float:left;width:9%;position:relative;left:1%;font-size:.6em}.periodic-map--squares{padding-bottom:1rem;padding-right:4px}.periodic-map--squares:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}[data-eq-state~=periodic-map-size-1] .periodic-map--square{font-size:.7em}[data-eq-state~=periodic-map-size-2] .periodic-map--square{font-size:.8em}[data-eq-state~=periodic-map-size-3] .periodic-map--square{font-size:.9em}[data-eq-state~=periodic-map-size-4] .periodic-map--square{font-size:1em}.periodic-map--square__background{height:0;padding-bottom:100%;position:relative;border:1px solid #fefefe;border-width:0 1px 1px 0;text-align:center;background-color:#d9d9d9}.bush .periodic-map--square__background{background-color:#c00}.carson .periodic-map--square__background{background-color:#7f042a}.christie .periodic-map--square__background{background-color:#b34452}.cruz .periodic-map--square__background{background-color:#bf2a4b}.fiorina .periodic-map--square__background{background-color:#c95b88}.huckabee .periodic-map--square__background{background-color:#bd0d55}.kasich .periodic-map--square__background{background-color:#5f4253}.paul .periodic-map--square__background{background-color:#fb1b17}.rubio .periodic-map--square__background{background-color:#7a537b}.santorum .periodic-map--square__background{background-color:#ff4c49}.trump .periodic-map--square__background{background-color:#fd5154}.clinton .periodic-map--square__background{background-color:#419bf9}.sanders .periodic-map--square__background{background-color:#03b9c5}.other .periodic-map--square__background{background-color:#ff885b!important}.periodic-map--square__labels{pointer-events:none;position:absolute;top:50%;width:100%;transform:translateY(-50%);text-transform:uppercase}.periodic-map--square__state-name{font-weight:200}.periodic-map--square__delegates,.periodic-map--square__state-name{font-size:.8em;padding:0;margin:0;font-weight:400}.periodic-map--square.voted{cursor:pointer;color:#fff}.periodic-map--square:nth-of-type(1){margin-left:90%}.periodic-map--square:nth-of-type(2){margin-left:81%}.periodic-map--square:nth-of-type(25){clear:left}.periodic-map--square:nth-of-type(35){margin-left:9%;clear:left}.periodic-map--square:nth-of-type(43){margin-left:27%;clear:left}.periodic-map--square:nth-of-type(48){clear:left}.periodic-map--square:nth-of-type(50){margin-left:9%}.periodic-map--square:nth-of-type(51){margin-left:36%}.periodic-map--square:nth-of-type(52){clear:left}[data-party=Rep] .periodic-map--square:nth-of-type(55){margin-left:54%}[data-party=Dem] .periodic-map--square:nth-of-type(55){margin-left:18%}[data-party=Dem] .periodic-map--square:nth-of-type(56){margin-left:27%}@media screen and (min-width:20em){.periodic-map--square__state-name{font-size:.8em;line-height:1em;font-weight:500}.periodic-map--square__delegates{font-size:1em;font-weight:300}}@media screen and (min-width:30em){.periodic-map--square__state-name{font-size:1.35em;line-height:1.25em;font-weight:400}.periodic-map--square__delegates{font-size:1.35em;font-weight:100}}body{margin:0}body .bush{color:#c00}body .carson{color:#7f042a}body .christie{color:#b34452}body .cruz{color:#bf2a4b}body .fiorina{color:#c95b88}body .huckabee{color:#bd0d55}body .kasich{color:#5f4253}body .paul{color:#fb1b17}body .rubio{color:#7a537b}body .santorum{color:#ff4c49}body .trump{color:#fd5154}body .clinton{color:#419bf9}body .sanders{color:#03b9c5}body .other{color:#ff885b}.cnn-delegate-roll-call--sharebar{margin-top:20px!important;display:block;position:relative;text-align:right;width:100%;padding:0}.cnn-delegate-roll-call--sharebar--container{display:block;position:relative}.cnn-delegate-roll-call--sharebar__btn{cursor:pointer;display:inline-block;width:35px;height:35px;margin-right:5px;padding:0;list-style-type:none;-webkit-transition:transform .5s ease 0s;transition:transform .5s ease 0s}.cnn-delegate-roll-call--sharebar__btn.email{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/email.png\");background-size:35px 35px}.cnn-delegate-roll-call--sharebar__btn.facebook{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/facebook.png\");background-size:35px 35px}.cnn-delegate-roll-call--sharebar__btn.twitter{background:url(\"http://i.cdn.turner.com/cnn/.e/img/4.0/interactive/sharebar/twitter.png\");background-size:35px 35px}.cnn-delegate-roll-call--sharebar__btn:hover{transform:scale(1.2);-webkit-transform:scale(1.2)}.cnn-delegate-roll-call--sharebar__btn:last-child{margin-right:0}.cnn-delegate-roll-call--sharebar:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.cnn-delegate-roll-call .bold{font-weight:500;letter-spacing:.05em}.cnn-delegate-roll-call--ad{display:block;position:relative;max-width:300px;margin:20px auto}.cnn-delegate-roll-call--app-call-out{display:block;position:relative;max-width:300px;margin:0 auto}.cnn-delegate-roll-call--section{margin-bottom:40px}.cnn-delegate-roll-call--section__title{text-transform:lowercase;font-weight:500;font-size:1.2em;margin:0 0 5px;padding:0}.cnn-delegate-roll-call--section__subtitle{text-transform:lowercase;font-size:.875em;font-weight:300;color:#a6a6a6;margin:0 0 20px;padding:0}.cnn-delegate-roll-call__toggle-btn{display:block;cursor:pointer;border:1px solid #d9d9d9;text-transform:lowercase;text-align:center;color:#a6a6a6;padding:10px;max-width:200px;margin:20px auto 0;transition:color .25s,border .25s}.cnn-delegate-roll-call__toggle-btn:hover{color:#419bf9;border:1px solid #419bf9}.cnn-delegate-roll-call__toggle-btn:before{content:\"Show more\"}.cnn-delegate-roll-call__toggle-btn[data-action=show-full-results__active]{display:none}.cnn-delegate-roll-call__toggle-btn[data-action=show-full-results__active]:before{content:\"Show more\"}.show-full-results__active .cnn-delegate-roll-call__toggle-btn[data-action=show-full-results__active]:before{content:\"Show less\"}.show-full-results .cnn-delegate-roll-call__toggle-btn[data-action=show-full-results__active]{display:block}.cnn-delegate-roll-call__toggle-btn[data-action=show-full-table__active]:before{content:\"Expand full list\"}.show-full-table__active .cnn-delegate-roll-call__toggle-btn[data-action=show-full-table__active]:before{content:\"Hide full list\"}.cnn-delegate-roll-call__winner{display:inline-block;visibility:hidden;position:relative;background:url(" + __webpack_require__(3) + ") no-repeat;background-size:20px 20px;vertical-align:middle;height:20px;width:20px;margin-left:5px;opacity:0;transition:opacity .5s,visibility 0ms .5s}.hp-module .cnn-delegate-roll-call__winner{background-size:15px 15px;height:15px;width:15px}.winner .cnn-delegate-roll-call__winner{visibility:visible;opacity:1;transition:opacity .5s}.cnn-delegate-roll-call__image{display:block;position:absolute;overflow:hidden;pointer-events:none;border:3px solid #fff;border-radius:50%;height:60px;width:60px;left:0;top:0;z-index:1}.bush .cnn-delegate-roll-call__image{background-color:#c00}.carson .cnn-delegate-roll-call__image{background-color:#7f042a}.christie .cnn-delegate-roll-call__image{background-color:#b34452}.cruz .cnn-delegate-roll-call__image{background-color:#bf2a4b}.fiorina .cnn-delegate-roll-call__image{background-color:#c95b88}.huckabee .cnn-delegate-roll-call__image{background-color:#bd0d55}.kasich .cnn-delegate-roll-call__image{background-color:#5f4253}.paul .cnn-delegate-roll-call__image{background-color:#fb1b17}.rubio .cnn-delegate-roll-call__image{background-color:#7a537b}.santorum .cnn-delegate-roll-call__image{background-color:#ff4c49}.trump .cnn-delegate-roll-call__image{background-color:#fd5154}.clinton .cnn-delegate-roll-call__image{background-color:#419bf9}.sanders .cnn-delegate-roll-call__image{background-color:#03b9c5}.other .cnn-delegate-roll-call__image{background-color:#ff885b!important}.hp-module .cnn-delegate-roll-call__image{display:none}.cnn-delegate-roll-call__title{display:inline-block;position:relative;vertical-align:middle;text-transform:lowercase;text-align:center;font-weight:600;min-width:60px;margin:5px 0;padding:0}.hp-module .cnn-delegate-roll-call__title{min-width:0;margin:0;text-align:left}.cnn-delegate-roll-call--delegate-count{display:block;margin-top:10px;margin-bottom:20px;width:100%;height:100px}.hp-module .cnn-delegate-roll-call--delegate-count{margin-bottom:0}.cnn-delegate-roll-call--delegate-count--container{display:block;position:absolute;width:100%;left:0}.cnn-delegate-roll-call--delegate-count--container:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.cnn-delegate-roll-call--delegate-count--container__cta{display:block;position:relative;background:#fd5154;text-transform:lowercase;line-height:1em;font-weight:200;font-size:1em;color:#fff;width:100%;padding:10px}.cnn-delegate-roll-call--delegate-count--container__cta:after{font-family:cnn-icons,CNN,Helvetica,Arial,sans-serif;content:\"\\F107\";float:right}.cnn-delegate-roll-call--delegate-count__remaining,.cnn-delegate-roll-call--delegate-count__total{display:block;position:relative;text-align:center;font-size:1.5em;line-height:.9em;float:left;margin:0;padding:10px;width:50%;font-weight:200}.hp-module .cnn-delegate-roll-call--delegate-count__remaining,.hp-module .cnn-delegate-roll-call--delegate-count__total{font-size:1.45rem;vertical-align:middle;padding:15px 10px}.cnn-delegate-roll-call--delegate-count__remaining:after,.cnn-delegate-roll-call--delegate-count__remaining:before,.cnn-delegate-roll-call--delegate-count__total:after,.cnn-delegate-roll-call--delegate-count__total:before{display:block;font-size:1rem;line-height:.9em;font-weight:200;width:100%;margin-top:5px;text-transform:lowercase}.hp-module .cnn-delegate-roll-call--delegate-count__remaining:after,.hp-module .cnn-delegate-roll-call--delegate-count__remaining:before,.hp-module .cnn-delegate-roll-call--delegate-count__total:after,.hp-module .cnn-delegate-roll-call--delegate-count__total:before{display:inline;font-size:.875rem;vertical-align:middle}.cnn-delegate-roll-call--delegate-count__remaining{color:#f2f2f2;background:#404040;text-align:right}.cnn-delegate-roll-call--delegate-count__remaining:after{content:\"remaining\"}.complete .cnn-delegate-roll-call--delegate-count__remaining:after{content:\"not voting\"}.hp-module .cnn-delegate-roll-call--delegate-count__remaining:after{content:none}.hp-module .cnn-delegate-roll-call--delegate-count__remaining:before{content:\"remaining\";margin-right:5px}.complete .hp-module .cnn-delegate-roll-call--delegate-count__remaining:before{content:\"not voting\"}.cnn-delegate-roll-call--delegate-count__total{color:#262626;background:#f2f2f2;text-align:left}.cnn-delegate-roll-call--delegate-count__total:after{content:\"total delegates\"}.hp-module .cnn-delegate-roll-call--delegate-count__total:after{content:\"total\";margin-left:5px}.cnn-delegate-roll-call--delegate-count:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.cnn-delegate-roll-call--overlay{display:block;visibility:hidden;position:fixed;background:#fff;border:2px solid #fff;min-width:250px;z-index:10;left:0;width:100%;height:auto;max-height:0%;bottom:0;box-shadow:0 0 20px 0 rgba(0,0,0,.3);transition:max-height .5s,visibility 0 .5s}.cnn-delegate-roll-call--overlay.show{visibility:visible;max-height:100%;transition:max-height .5s}.cnn-delegate-roll-call--overlay-content--header{overflow:hidden;padding:10px;color:#fff}.bush .cnn-delegate-roll-call--overlay-content--header{background-color:#c00}.carson .cnn-delegate-roll-call--overlay-content--header{background-color:#7f042a}.christie .cnn-delegate-roll-call--overlay-content--header{background-color:#b34452}.cruz .cnn-delegate-roll-call--overlay-content--header{background-color:#bf2a4b}.fiorina .cnn-delegate-roll-call--overlay-content--header{background-color:#c95b88}.huckabee .cnn-delegate-roll-call--overlay-content--header{background-color:#bd0d55}.kasich .cnn-delegate-roll-call--overlay-content--header{background-color:#5f4253}.paul .cnn-delegate-roll-call--overlay-content--header{background-color:#fb1b17}.rubio .cnn-delegate-roll-call--overlay-content--header{background-color:#7a537b}.santorum .cnn-delegate-roll-call--overlay-content--header{background-color:#ff4c49}.trump .cnn-delegate-roll-call--overlay-content--header{background-color:#fd5154}.clinton .cnn-delegate-roll-call--overlay-content--header{background-color:#419bf9}.sanders .cnn-delegate-roll-call--overlay-content--header{background-color:#03b9c5}.other .cnn-delegate-roll-call--overlay-content--header{background-color:#ff885b}.cnn-delegate-roll-call--overlay-content--header__title{display:inline-block;vertical-align:middle;font-size:1.25em;line-height:2.2rem;font-weight:400;padding:0;margin:0}.cnn-delegate-roll-call--overlay-content--header__delegates{display:block;position:relative;text-align:right;vertical-align:middle;font-size:1.875em;font-weight:100;padding:0;margin:0;float:right}.cnn-delegate-roll-call--overlay-content--header__delegates:after{display:block;content:\"total delegates\";font-size:.85rem;vertical-align:baseline;margin:-5px 0 5px;padding:0}.cnn-delegate-roll-call--overlay-content--list{padding:10px;margin:0}.cnn-delegate-roll-call--overlay-content--list__item{position:relative;border-bottom:1px solid #e6e6e6;list-style:none;padding:2px 0;margin:0}.cnn-delegate-roll-call--overlay-content--list__item:last-child{border-bottom:none}.cnn-delegate-roll-call--overlay-content--list__item .cnn-delegate-roll-call__image{height:30px;width:30px;display:inline-block;position:relative;vertical-align:middle;margin-right:5px}.cnn-delegate-roll-call--overlay-content--list__item .cnn-delegate-roll-call__title{display:inline-block;vertical-align:middle;position:relative;margin:0 auto;vertical-align:midde;min-width:0}.cnn-delegate-roll-call--overlay-content--list__item__rd{display:inline-block;position:relative;vertical-align:midde;font-size:1em;padding:2px 0;margin:0}.cnn-delegate-roll-call--overlay-content--list__item:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.cnn-delegate-roll-call--overlay__close-btn{cursor:pointer;padding:10px;border-radius:5px;background-color:#ee3738;color:#fff;font-weight:300;text-align:center;font-size:1.1em;margin:10px auto 20px;max-width:200px}.cnn-delegate-roll-call--results-card{display:block;position:relative;margin-bottom:20px}.hp-module .cnn-delegate-roll-call--results-card{padding:0 10px}.hp-module .cnn-delegate-roll-call--results-card .cnn-delegate-roll-call--results-card__nom,.hp-module .cnn-delegate-roll-call--results-card .cnn-delegate-roll-call--results-card__td{display:none}.hp-module .cnn-delegate-roll-call--results-card:nth-child(1) .cnn-delegate-roll-call--results-card__nom,.hp-module .cnn-delegate-roll-call--results-card:nth-child(1) .cnn-delegate-roll-call--results-card__td{display:block}.cnn-delegate-roll-call--results-card:nth-child(3){margin-bottom:40px}.cnn-delegate-roll-call--results-card.snapshot{margin-bottom:20px}.cnn-delegate-roll-call--results-card.full-results{visibility:hidden;margin-bottom:0;max-height:0;opacity:0;transition:max-height .5s,margin-bottom .5s,visibility 0ms .5s,opacity .5s}.show-full-results__active .cnn-delegate-roll-call--results-card.full-results{visibility:visible;max-height:100px;margin-bottom:40px;opacity:1;transition:max-height .5s,margin-bottom .5s,opacity .5s}.show-full-results__active .cnn-delegate-roll-call--results-card.full-results.snapshot{margin-bottom:30px}.hp-module .cnn-delegate-roll-call--results-card{margin-bottom:0}.cnn-delegate-roll-call--results-card__rd{position:relative;font-weight:100;font-size:1.75em;line-height:1.2em;padding:0;margin:2px 0;margin-left:65px}.snapshot .cnn-delegate-roll-call--results-card__rd{line-height:55px;margin-bottom:5px}.hp-module .cnn-delegate-roll-call--results-card__rd{margin-left:0;margin-bottom:4px;font-size:1.6em}.cnn-delegate-roll-call--results-card__nom,.cnn-delegate-roll-call--results-card__td{position:absolute;text-align:right;margin:0;padding:15px 0 0;margin-right:-2px}.cnn-delegate-roll-call--results-card__nom:after,.cnn-delegate-roll-call--results-card__td:after{display:block;font-size:11px;text-transform:lowercase}.hp-module .cnn-delegate-roll-call--results-card__nom,.hp-module .cnn-delegate-roll-call--results-card__td{font-size:14px;font-weight:300;color:#a6a6a6}.hp-module .cnn-delegate-roll-call--results-card__nom:after,.hp-module .cnn-delegate-roll-call--results-card__td:after{margin-top:-4px}.snapshot .cnn-delegate-roll-call--results-card__nom,.snapshot .cnn-delegate-roll-call--results-card__td{display:none}.cnn-delegate-roll-call--results-card__td{right:0}.cnn-delegate-roll-call--results-card__td:after{content:\"Total delegates\"}.cnn-delegate-roll-call--results-card__nom{margin-right:-15px;right:50%}.cnn-delegate-roll-call--results-card__nom:after{content:\"Needed to win\"}.hp-module .cnn-delegate-roll-call--results-card__nom{text-align:center}.hp-module .cnn-delegate-roll-call--results-card__nom:after{content:\"to win\"}.cnn-delegate-roll-call--results-card__status{display:block;position:relative;color:#bfbfbf;padding-left:2.6875em;margin-bottom:5px;width:100%}.snapshot .cnn-delegate-roll-call--results-card__status{display:none}.hp-module .cnn-delegate-roll-call--results-card__status{padding-left:0}.cnn-delegate-roll-call--results-card--status-bar{display:block;position:relative;background-color:#e6e6e6;height:20px;width:100%}.hp-module .cnn-delegate-roll-call--results-card--status-bar{height:10px}.cnn-delegate-roll-call--results-card--status-bar:after,.cnn-delegate-roll-call--results-card--status-bar:before{content:\" \";display:block;position:absolute;height:200%;top:-50%;z-index:1}.hp-module .cnn-delegate-roll-call--results-card--status-bar:after,.hp-module .cnn-delegate-roll-call--results-card--status-bar:before{height:300%;top:-100%}.cnn-delegate-roll-call--results-card--status-bar:before{border-right:1px solid #ff885b;right:50%}.cnn-delegate-roll-call--results-card--status-bar:after{border-right:1px solid #bfbfbf;right:0}.cnn-delegate-roll-call--results-card--status-bar__indicator{display:block;position:absolute;height:100%;width:0;left:0;top:0;transition:width .5s}.bush .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#c00}.carson .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#7f042a}.christie .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#b34452}.cruz .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#bf2a4b}.fiorina .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#c95b88}.huckabee .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#bd0d55}.kasich .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#5f4253}.paul .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#fb1b17}.rubio .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#7a537b}.santorum .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#ff4c49}.trump .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#fd5154}.clinton .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#419bf9}.sanders .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#03b9c5}.other .cnn-delegate-roll-call--results-card--status-bar__indicator{background-color:#ff885b}.cnn-delegate-roll-call--results-table--header{position:relative;border-bottom:1px solid #f2f2f2;padding-bottom:10px}.cnn-delegate-roll-call--results-table--header__title{margin:0;padding:0;font-size:1.05em;font-weight:200;text-transform:lowercase;vertical-align:baseline;color:#a6a6a6;height:110px}.cnn-delegate-roll-call--results-table--header__title:before{position:relative;content:\" \";display:inline-block;height:100%;width:1px;vertical-align:baseline}.cnn-delegate-roll-call--results-table--header__candidate{position:relative}.cnn-delegate-roll-call--results-table--header__candidate .cnn-delegate-roll-call__image{position:relative;margin:0 auto}.cnn-delegate-roll-call--results-table--header__candidate .cnn-delegate-roll-call__title{display:block;position:relative;margin:0 auto}.cnn-delegate-roll-call--results-table--header__candidate__rd{font-size:1.875em;text-align:center;font-weight:100;padding:0;margin:5px 0 0}.cnn-delegate-roll-call--results-table--list{padding:0;margin:0}.cnn-delegate-roll-call--results-table--list__item{visibility:hidden;overflow:hidden;background-color:transparent;list-style:none;border-bottom:0 solid #f2f2f2;max-height:0;opacity:0;transition:border .5s,max-height .5s,opacity .5s,visibility 0ms .5s,background-color .2s}.cnn-delegate-roll-call--results-table--list__item:nth-child(1),.cnn-delegate-roll-call--results-table--list__item:nth-child(2),.cnn-delegate-roll-call--results-table--list__item:nth-child(3),.cnn-delegate-roll-call--results-table--list__item:nth-child(4),.cnn-delegate-roll-call--results-table--list__item:nth-child(5),.show-full-table__active .cnn-delegate-roll-call--results-table--list__item{border-bottom:1px solid #f2f2f2;visibility:visible;max-height:100px;opacity:1;transition:border .5s,max-height .5s,opacity .5s,background-color .2s}.cnn-delegate-roll-call--results-table--list__item:hover{background-color:#fffef0}.cnn-delegate-roll-call--results-table--list__item__title{font-size:.9em;line-height:2em;font-weight:400;padding:10px;margin:0}.cnn-delegate-roll-call--results-table--list__item__result{padding:10px;text-align:center}.cnn-delegate-roll-call--results-table--list__item__result__value{position:relative;display:inline-block;border-radius:3px;letter-spacing:.05em;font-size:1.25em;font-weight:500;margin:0}.cnn-delegate-roll-call--results-table--list__item__result__value.bush{color:#c00}.cnn-delegate-roll-call--results-table--list__item__result__value.carson{color:#7f042a}.cnn-delegate-roll-call--results-table--list__item__result__value.christie{color:#b34452}.cnn-delegate-roll-call--results-table--list__item__result__value.cruz{color:#bf2a4b}.cnn-delegate-roll-call--results-table--list__item__result__value.fiorina{color:#c95b88}.cnn-delegate-roll-call--results-table--list__item__result__value.huckabee{color:#bd0d55}.cnn-delegate-roll-call--results-table--list__item__result__value.kasich{color:#5f4253}.cnn-delegate-roll-call--results-table--list__item__result__value.paul{color:#fb1b17}.cnn-delegate-roll-call--results-table--list__item__result__value.rubio{color:#7a537b}.cnn-delegate-roll-call--results-table--list__item__result__value.santorum{color:#ff4c49}.cnn-delegate-roll-call--results-table--list__item__result__value.trump{color:#fd5154}.cnn-delegate-roll-call--results-table--list__item__result__value.clinton{color:#419bf9}.cnn-delegate-roll-call--results-table--list__item__result__value.sanders{color:#03b9c5}.cnn-delegate-roll-call--results-table--list__item__result__value.other{color:#ff885b}.cnn-delegate-roll-call--results-table--list__item__result__value.major{padding:2px 8px;color:#fff}.cnn-delegate-roll-call--results-table--list__item__result__value.major.bush{background-color:#c00}.cnn-delegate-roll-call--results-table--list__item__result__value.major.carson{background-color:#7f042a}.cnn-delegate-roll-call--results-table--list__item__result__value.major.christie{background-color:#b34452}.cnn-delegate-roll-call--results-table--list__item__result__value.major.cruz{background-color:#bf2a4b}.cnn-delegate-roll-call--results-table--list__item__result__value.major.fiorina{background-color:#c95b88}.cnn-delegate-roll-call--results-table--list__item__result__value.major.huckabee{background-color:#bd0d55}.cnn-delegate-roll-call--results-table--list__item__result__value.major.kasich{background-color:#5f4253}.cnn-delegate-roll-call--results-table--list__item__result__value.major.paul{background-color:#fb1b17}.cnn-delegate-roll-call--results-table--list__item__result__value.major.rubio{background-color:#7a537b}.cnn-delegate-roll-call--results-table--list__item__result__value.major.santorum{background-color:#ff4c49}.cnn-delegate-roll-call--results-table--list__item__result__value.major.trump{background-color:#fd5154}.cnn-delegate-roll-call--results-table--list__item__result__value.major.clinton{background-color:#419bf9}.cnn-delegate-roll-call--results-table--list__item__result__value.major.sanders{background-color:#03b9c5}.cnn-delegate-roll-call--results-table--list__item__result__value.major.other{background-color:#ff885b}.cnn-delegate-roll-call--results-table--list__item__result__value:before{content:\" \";position:absolute;visibility:hidden;background:url(" + __webpack_require__(3) + ") no-repeat;background-size:14px 14px;vertical-align:middle;height:14px;width:14px;left:-19px;top:5px;opacity:0;transition:opacity .5s,visibility 0ms .5s}.cnn-delegate-roll-call--results-table--list__item__result__value.winner:before{visibility:visible;opacity:1;transition:opacity .5s}@media screen and (min-width:30em){.cnn-delegate-roll-call--section__title{font-size:1.375rem}.cnn-delegate-roll-call--section__subtitle{font-size:1rem;font-weight:200}.cnn-delegate-roll-call--overlay{display:none;visibility:visible;width:auto;height:auto;bottom:auto;transition:none;max-height:auto}.cnn-delegate-roll-call--overlay.show{visibility:visible;max-height:auto;display:block}.cnn-delegate-roll-call--overlay__close-btn{display:none}.cnn-delegate-roll-call--delegate-count{display:block;margin-top:10px;width:100%}.hp-module .cnn-delegate-roll-call--delegate-count{height:95px}.cnn-delegate-roll-call--delegate-count--container{display:block;position:relative;width:100%;left:auto}.hp-module .cnn-delegate-roll-call--delegate-count--container{display:block;position:absolute;width:100%;left:0}.hp-module .cnn-delegate-roll-call--delegate-count--container:after{content:\" \";display:block;clear:both;line-height:0;height:0;zoom:1}.cnn-delegate-roll-call--delegate-count--container__cta{display:none}.hp-module .cnn-delegate-roll-call--delegate-count--container__cta{display:block}.cnn-delegate-roll-call--delegate-count__remaining,.cnn-delegate-roll-call--delegate-count__total{position:relative;display:inline-block;background:transparent;border:1px solid #88a4b9;text-align:center;font-size:2.5em;color:#262626;margin:0 10px 60px 0;padding:10px 0;width:33%}.cnn-delegate-roll-call--delegate-count__remaining:after,.cnn-delegate-roll-call--delegate-count__remaining:before,.cnn-delegate-roll-call--delegate-count__total:after,.cnn-delegate-roll-call--delegate-count__total:before{display:block;position:absolute;font-size:1rem;font-weight:200;width:100%;text-transform:lowercase;bottom:-25px}.hp-module .cnn-delegate-roll-call--delegate-count__remaining,.hp-module .cnn-delegate-roll-call--delegate-count__total{display:inline-block;position:relative;border:none;text-align:center;font-size:1.45em;line-height:.9em;float:left;margin:0;padding:15px 10px;width:50%;font-weight:200}.hp-module .cnn-delegate-roll-call--delegate-count__remaining:after,.hp-module .cnn-delegate-roll-call--delegate-count__remaining:before,.hp-module .cnn-delegate-roll-call--delegate-count__total:after,.hp-module .cnn-delegate-roll-call--delegate-count__total:before{display:inline;position:relative;font-size:.875rem;line-height:.9em;font-weight:300;width:100%;margin-top:5px;text-transform:lowercase;vertical-align:middle;bottom:auto}.cnn-delegate-roll-call--delegate-count__remaining:after{content:\"remaining\"}.complete .cnn-delegate-roll-call--delegate-count__remaining:after{content:\"not voting\"}.hp-module .cnn-delegate-roll-call--delegate-count__remaining{color:#f2f2f2;background:#404040;text-align:right}.hp-module .cnn-delegate-roll-call--delegate-count__remaining:after{content:none}.hp-module .cnn-delegate-roll-call--delegate-count__remaining:before{content:\"remaining\";margin-right:5px}.complete .hp-module .cnn-delegate-roll-call--delegate-count__remaining:before{content:\"not voting\"}.hp-module .cnn-delegate-roll-call--delegate-count__total{color:#262626;background:#f2f2f2;text-align:left}.hp-module .cnn-delegate-roll-call--delegate-count__total:after{content:\"total\";margin-left:5px}}@media screen and (min-width:48em){.cnn-delegate-roll-call--results-table--list__item__title{font-size:1.175em;line-height:1.2em;font-weight:300;padding:10px;margin:0}}", ""]);
	
	// exports


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "media/assets/politics-app-cta.png";

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "media/images/clinton.jpg";

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "media/images/other.png";

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "media/images/sanders.jpg";

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(1);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(26),
	    isHostObject = __webpack_require__(49),
	    isMasked = __webpack_require__(52),
	    isObject = __webpack_require__(4),
	    toSource = __webpack_require__(56);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var createCtorWrapper = __webpack_require__(5),
	    root = __webpack_require__(1);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBaseWrapper(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBaseWrapper;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(15),
	    createCtorWrapper = __webpack_require__(5),
	    createHybridWrapper = __webpack_require__(20),
	    createRecurryWrapper = __webpack_require__(21),
	    getHolder = __webpack_require__(23),
	    replaceHolders = __webpack_require__(11),
	    root = __webpack_require__(1);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurryWrapper(func, bitmask, arity) {
	  var Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurryWrapper;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(15),
	    createCtorWrapper = __webpack_require__(5),
	    root = __webpack_require__(1);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartialWrapper(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartialWrapper;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(16),
	    createBaseWrapper = __webpack_require__(42),
	    createCurryWrapper = __webpack_require__(43),
	    createHybridWrapper = __webpack_require__(20),
	    createPartialWrapper = __webpack_require__(44),
	    getData = __webpack_require__(22),
	    mergeData = __webpack_require__(53),
	    setData = __webpack_require__(25),
	    toInteger = __webpack_require__(65);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBaseWrapper(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurryWrapper(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartialWrapper(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybridWrapper.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setter(result, newData);
	}
	
	module.exports = createWrapper;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(54);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(38),
	    getValue = __webpack_require__(48);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 48 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 50 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(8),
	    getData = __webpack_require__(22),
	    getFuncName = __webpack_require__(46),
	    lodash = __webpack_require__(67);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(40);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(17),
	    composeArgsRight = __webpack_require__(18),
	    replaceHolders = __webpack_require__(11);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	    ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 54 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(19),
	    isIndex = __webpack_require__(50);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 56 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(8),
	    LodashWrapper = __webpack_require__(14),
	    copyArray = __webpack_require__(19);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(45);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 60 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(27);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * A method that returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	function now() {
	  return Date.now();
	}
	
	module.exports = now;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(66);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(64);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(26),
	    isObject = __webpack_require__(4),
	    isSymbol = __webpack_require__(61);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(8),
	    LodashWrapper = __webpack_require__(14),
	    baseLodash = __webpack_require__(10),
	    isArray = __webpack_require__(60),
	    isObjectLike = __webpack_require__(27),
	    wrapperClone = __webpack_require__(57);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array of at least `200` elements
	 * and any iteratees accept only one argument. The heuristic for whether a
	 * section qualifies for shortcut fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	 * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	 * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	 * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	 * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	 * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	 * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	 * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	 * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	 * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 68 */,
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(32);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js?outputStyle=expanded&includePaths[]=/Users/kuzquiano/Projects/CNN/CNNInteractive/cnn-interactive-convention-delegate-roll-call/node_modules/compass-mixins/lib&includePaths[]=/Users/kuzquiano/Projects/CNN/CNNInteractive/cnn-interactive-convention-delegate-roll-call/bower_components&includePaths[]=/Users/kuzquiano/Projects/CNN/CNNInteractive/cnn-interactive-convention-delegate-roll-call/node_modules!./cnn-interactive-delegate-roll-call.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js?outputStyle=expanded&includePaths[]=/Users/kuzquiano/Projects/CNN/CNNInteractive/cnn-interactive-convention-delegate-roll-call/node_modules/compass-mixins/lib&includePaths[]=/Users/kuzquiano/Projects/CNN/CNNInteractive/cnn-interactive-convention-delegate-roll-call/bower_components&includePaths[]=/Users/kuzquiano/Projects/CNN/CNNInteractive/cnn-interactive-convention-delegate-roll-call/node_modules!./cnn-interactive-delegate-roll-call.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./assets/politics-app-cta.png": 33,
		"./assets/winner.png": 3,
		"./images/clinton.jpg": 34,
		"./images/other.png": 35,
		"./images/sanders.jpg": 36
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 70;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** js/cnn-interactive-delegate-roll-call.js
 **/